/** SOLICITUD DEL ORDEN DEL ALTA DEL ESTABLECIMIENTO*/
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useAuth } from "../components/content/auth.jsx";
import { Api } from "./../app-controller.js";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import Swal from "sweetalert2";
import Select from "react-select";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

const hiddenFileInput = React.createRef(null);

class ReceiptRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tramite_id: "",
      disabled: true,
      options_activities: [],
      options_productos: [],
      productos: [],
      //Formulario Medico
      establecimiento: {
        id: "",
        razon_social: "",
        guid: "",
      },
      establecimientos: [],
      tipo_documento_id: "",
      documentos_medico_veterinario: [],
      docsRequired: [],
      document_type_temp: 0,
      telefono: "",
      maxLength: 8,
      regente: [],
      est_nacional: [],
      reg_id: "",
      reg_tipo_id: "",
      representante_nom: "",
      options_documents: [],
      recs: 0,
      peticionMaxLen: 10000,
      establecimiento_id_baja: "",
      licencia_id_baja_e: "",
      tipo_establecimiento_baja_id: "",
      productos_refrenda: [],
      options_productos_refrenda: [],
      ame: "",
      tipo_precertificado: "",
      options_fin_exportacion: Api.loadCatalogue("cat_fin_exportacion"),
      //opciones_ame: Api.loadCatalogue("cat_anotacion_marginal"),
      precertificado: {
        tipo_precertificado: "",
        cantidad: "",
        num_factura: "",
        facturas: [],
        fin_exportacion_id: "",
      },
      existe_orden: false,
      tipo_productos: [],
      tipo_producto_id: "",
      disable_ame: false,
    };

    /**Declaro las funciones handle */
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRegister = this.handleRegister.bind(this);

    this.handleTipoEstablecimiento = this.handleTipoEstablecimiento.bind(this);
    this.handleGuidEstablecimiento = this.handleGuidEstablecimiento.bind(this);
    this.handleExisteEstablecimiento =
      this.handleExisteEstablecimiento.bind(this);

    /* this.addEstablecimientos = this.addEstablecimientos.bind(this);
    this.removeEstablecimientos = this.removeEstablecimientos.bind(this); */

    this.mensajeError = this.mensajeError.bind(this);

    this.validarFormConstancia = this.validarFormConstancia.bind(this);
    this.limpiarForm = this.limpiarForm.bind(this);

    this.handleEstablecimientosRepRegTitularesFabricantes =
      this.handleEstablecimientosRepRegTitularesFabricantes.bind(this);
    this.handleProductosChange = this.handleProductosChange.bind(this);

    this.handleAnotacionMarginalEstablecimiento =
      this.handleAnotacionMarginalEstablecimiento.bind(this);
    this.handleBajaEstablecimiento = this.handleBajaEstablecimiento.bind(this);
    this.handleChangeEstablecimientoBaja =
      this.handleChangeEstablecimientoBaja.bind(this);
    this.handleChangeTipoEstablecimientoBaja =
      this.handleChangeTipoEstablecimientoBaja.bind(this);

    this.handleProductosRefrendaChange =
      this.handleProductosRefrendaChange.bind(this);
    this.limpiarForm_Refrenda = this.limpiarForm_Refrenda.bind(this);
    this.validarFormRefrenda = this.validarFormRefrenda.bind(this);

    this.handlePreCertificado = this.handlePreCertificado.bind(this);
    this.addNumFacturaPrecertificado =
      this.addNumFacturaPrecertificado.bind(this);
    this.removeNumFacturaPrecertificado =
      this.removeNumFacturaPrecertificado.bind(this);
    this.handlePreCertificadoProducto =
      this.handlePreCertificadoProducto.bind(this);

    this.handleCasoEspecial = this.handleCasoEspecial.bind(this);
  }

  sol = "";
  forma_MedicoVeterinario = "";
  forma_constancias = "";
  forma_Refrenda = "";
  componentDidMount() {
    let tipoEstablecimiento = Api.loadCatalogue("cat_tipo_establecimiento");
    let losestablecimientos = [];
    let medico = document.querySelector("#f_MedicoVeterinario");
    //let tablaEstablecimiento = document.querySelector("#tablaEstablecimiento");
    let btn_generar = document.querySelector("#btn_generar");
    let constancia = document.querySelector("#f_constancias");
    let constancia_productos = document.querySelector("#check_productos");
    let refrenda = document.querySelector("#f_refrenda");
    let refreda_productos = document.querySelector("#refreda_productos");

    let solicitud_orden = {
      target: "#solicitud",
      class: "",
      elementClass: "form-control",
      name: "frmSol",
      elements: [
        {
          select: {
            name: "tramite_id",
            label: "Tipo Trámite",
            placeHolder: "Seleccione",
            cols: 12,
          },
        },
        {
          select: {
            name: "esNuevo",
            label: "¿Nuevo establecimiento?",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "tipoProducto",
            label: "Tipo producto",
            cols: 6,
            hide: true,
          },
        },
        {
          select: {
            name: "tipoRegistro",
            label: "Tipo registro",
            cols: 6,
            hide: true,
          },
        },
        {
          select: {
            name: "tipo_certificado",
            label: "Seleccione",
            cols: 12,
            hide: true,
          },
        },
        {
          input: {
            name: "num_certificados",
            label:
              "Número de certificados(Número de países a enviar producto):",
            cols: 12,
            hide: true,
            placeHolder: "",
            type: "number",
            min: "1",
            //onkeyup:"this.value = this.value.toUpperCase();"
          },
        },
        {
          input: {
            name: "cantidad_precertificado",
            label:
              "Cantidad de precertificados y/o constancias de exportación.",
            cols: 12,
            hide: true,
            type: "number",
            min: "1",
            //placeHolder: "ej. 1",
          },
        },
        {
          select: {
            name: "tipo_precertificado",
            label: "Tipo precertificado",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "establecimiento",
            label: "Seleccione",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "tipo",
            label: "Tipo establecimiento",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "actividad",
            label: "Actividad",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "reposicionLicRegente",
            label: "Seleccione",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "licencia_establecimiento",
            label: "Seleccione",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "renovacion_establecimiento",
            label: "Seleccione",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "productos",
            label: "Seleccione",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "anotacion_marginal",
            label: "Seleccione",
            cols: 12,
            hide: true,
          },
        },
        {
          input: {
            name: "nombre_persona",
            label: "Orden a nombre de",
            cols: 12,
            hide: true,
            placeHolder: "Nombre completo",
            type: "text",
            onkeyup: "this.value = this.value.toUpperCase();",
          },
        },
        {
          button: {
            name: "generarSol",
            // type: "submit",
            class: "form-control btn btn-lg btn-primary",
            cols: 12,
            text: "Generar",
            hide: true,
            click: (me, data) => {
              this.handleSubmit(this.sol.data());
            },
          },
        },
      ],
      onchange: (me, data, serial) => {
        //

        switch (me.name) {
          case "tramite_id":
            let precertificado_lim = {
              tipo_precertificado: "",
              cantidad: "",
              num_factura: "",
              facturas: [],
              fin_exportacion_id: "",
            };

            let establecimento_lim = {
              id: "",
              razon_social: "",
              guid: "",
            };

            document.querySelector("#ame").classList = "hide";
            document.querySelector("#ameGuid").classList = "hide";
            document.querySelector("#addEst").classList =
              "form-control btn btn-light";
            document.querySelector("#addEst i").classList = "fa fa-th";

            this.setState({ tramite_id: me.value });
            this.setState({
              ame: "",
              establecimiento_id_baja: "",
              licencia_id_baja_e: "",
              tipo_establecimiento_baja_id: "",
              precertificado: precertificado_lim,
              establecimento: establecimento_lim,
              disable_ame: false,
            });
            this.sol.hide("nombre_persona");
            this.setState({ existe_orden: false });

            if (me.value === "22") {
              let cat_tipo_importacion = Api.loadCatalogue(
                "cat_tipo_importacion"
              );

              let comboTipoImportacion = `<option value="">Seleccione tipo de importación</option>`;
              for (let tipoImportacion in cat_tipo_importacion) {
                comboTipoImportacion += `<option value="${cat_tipo_importacion[tipoImportacion].id}">
                              ${cat_tipo_importacion[tipoImportacion].descripcion}
                      </option>`;
              }

              let cmbTipoImp = document.querySelector("#tipoimportacion");

              cmbTipoImp.innerHTML = comboTipoImportacion;
              cmbTipoImp.addEventListener("change", (e) => {
                if (
                  e.target.value === "1" ||
                  e.target.value === "7" ||
                  e.target.value === "8"
                ) {
                  document.querySelector("#estiim").classList = "";
                  Api.fetch(
                    "app/getEstablecimientosRepRegTipoImportacion?tipo=" +
                      e.target.value
                  ).then((data) => {
                    let cmbCE = `<option value="">Seleccione el establecimiento</option>`;
                    for (let o in data) {
                      cmbCE += `<option value=${data[o].id}>${data[o].razon_social} [${data[o].folio_establecimiento}]</option>`;
                    }
                    let ce_est = document.querySelector("#ce_establecimientos");
                    ce_est.innerHTML = cmbCE;
                    ce_est.addEventListener("change", (c) => {
                      document.querySelector("#btn_generar").classList = "";
                    });
                  });
                } else {
                  document.querySelector("#estiim").classList = "hide";
                  document.querySelector("#btn_generar").classList = "";
                  document.querySelector("#ce_establecimientos").value = "";
                }
              });

              //return;
            }

            if (me.value === "3") {
              //Licencia establecimiento
              // Preparamos el combo es nuevo
              let opt = `<option value=1>Si</option><option value=0>No</option>`;
              this.sol.querySelector("#esNuevo").innerHTML = opt;

              //se muestra el tipo de establecimiento desde el principio
              let optionsE = `<option value="">Seleccione tipo de establecimiento</option>`;
              //sol.querySelector("#tipo").innerHTML=options;
              Api.fetch("app/getCatTipoEstablecimientoRegente").then((data) => {
                if (data) {
                  let tipoEstablecimiento = data;
                  for (let tipo in tipoEstablecimiento) {
                    optionsE += `<option className="n-${tipoEstablecimiento[tipo].nacional} otipo" value="${tipoEstablecimiento[tipo].id}">
                    ${tipoEstablecimiento[tipo].descripcion}
                    </option>`;
                  }
                }
                this.sol.querySelector("#tipo").innerHTML = optionsE;
              });

              /*              for (let tipo in tipoEstablecimiento) {
                options += `<option className="n-${tipoEstablecimiento[tipo].nacional} otipo" value="${tipoEstablecimiento[tipo].id}">
                    ${tipoEstablecimiento[tipo].descripcion}
                    </option>`;
                }
  */

              let options = `<option value="">Seleccione actividad</option>`;
              this.sol.querySelector("#actividad").innerHTML = options;

              this.sol.querySelector(".esNuevo").classList =
                "form-group esNuevo";
              this.sol.querySelector("#esNuevo").value = "1";
              this.sol.querySelector(".tipo").classList = "form-group tipo";
              this.sol.querySelector(".actividad").classList =
                "form-group actividad";
              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              //Oculta y cambia valor: llegan al controlador vacio ("")
              this.sol.hide([
                "tipoProducto",
                "establecimiento",
                "tipoRegistro",
                "reposicionLicRegente",
                "cantidad_precertificado",
                "licencia_establecimiento",
                "productos",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              this.sol.hide("nombre_persona");
              this.sol.querySelector("#tipoProducto").value = "";
              this.sol.querySelector("#establecimiento").value = "";
              this.sol.querySelector("#tipoRegistro").value = "";
              this.sol.querySelector("#licencia_establecimiento").value = "";

              //medico.classList="hide";
              //tablaEstablecimiento.classList="hide";
              btn_generar.classList = "hide";
              constancia.classList = "hide";
              constancia_productos.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
            } else if (me.value === "4") {
              this.sol.querySelector(".establecimiento").classList =
                "form-group hide establecimiento";
              this.sol.querySelector("#establecimiento").value = "";
              this.sol.querySelector(".tipoProducto").classList =
                "form-group tipoProducto";
              this.sol.querySelector(".tipoRegistro").classList =
                "form-group tipoRegistro";
              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              //Oculta y cambia valor: llegan al controlador vacio ("")
              this.sol.hide([
                "esNuevo",
                "tipo",
                "actividad",
                "establecimiento",
                "reposicionLicRegente",
                "licencia_establecimiento",
                "cantidad_precertificado",
                "productos",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              this.sol.hide("nombre_persona");
              this.sol.querySelector("#esNuevo").value = "";
              this.sol.querySelector("#tipo").value = "";
              this.sol.querySelector("#actividad").value = "";
              this.sol.querySelector("#licencia_establecimiento").value = "";
              this.sol.querySelector("#establecimiento").value = "";

              //medico.classList="hide";
              //tablaEstablecimiento.classList="hide";
              btn_generar.classList = "hide";
              constancia.classList = "hide";
              constancia_productos.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";

              /*************PARA TRAMITE DE PRODUCTO */
              // Fetch a mis tipos de productos
              Api.fetch("app/getTipoProductoRegente").then((data) => {
                if (data) {
                  let tipoProducto = data;

                  let comboProductos =
                    '<option value="">Seleccione producto</option>';
                  for (let tipo in tipoProducto) {
                    comboProductos += `<option value="${tipoProducto[tipo].id}">${tipoProducto[tipo].descripcion}</option>`;
                  }

                  this.sol.querySelector("#tipoProducto").innerHTML =
                    comboProductos;
                }
              });

              // Preparamos combo registro
              let registros2 = Api.loadCatalogue("cat_tipo_registro");
              let comboRegistro2 = `<option value="">Seleccione registro</option>`;
              for (let registro in registros2) {
                comboRegistro2 += `<option value="${registros2[registro].id}">
                            ${registros2[registro].descripcion}
                    </option>`;
              }
              registros2 = this.sol.querySelector("#tipoRegistro");
              registros2.innerHTML = comboRegistro2;
            } else if (me.value === "6") {
              //Constancias
              constancia.classList = "";
              btn_generar.classList = "";

              this.sol.hide([
                "esNuevo",
                "establecimiento",
                "tipo",
                "nombre_persona",
                "actividad",
                "reposicionLicRegente",
                "generarSol",
                "tipoProducto",
                "cantidad_precertificado",
                "tipoRegistro",
                "licencia_establecimiento",
                "productos",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              this.sol.querySelector("#establecimiento").value = "";
              this.sol.querySelector("#licencia_establecimiento").value = "";

              //medico.classList="hide";
              //tablaEstablecimiento.classList="hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
              //constancia_productos.classList="hide";
            } else if (me.value === "7") {
              //Anotacion marginal establecimiento

              this.sol.hide([
                "tipo",
                "esNuevo",
                "generarSol",
                "actividad",
                "reposicionLicRegente",
                "cantidad_precertificado",
                "establecimiento",
                "licencia_establecimiento",
                "productos",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
                "tipoProducto",
                "tipoRegistro",
              ]);

              this.sol.hide("nombre_persona");
              this.forma_constancias.classList = "hide";
              btn_generar.classList = "";
              constancia_productos.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";

              let options ='<option value="">Seleccione anotación</option>';
              let opt_ame = document.querySelector("#cmbanotaciones");
              let anotacionesList = document.querySelector("#anotaciones");
              anotacionesList.classList = "form-control";

              Api.fetch("app/getAllAnotacionEstablecimiento").then((data) => {
                if (data) {
                  let anotaciones = data;
                  for (let e in anotaciones) {
                    options += `<option value="${anotaciones[e].id}">${anotaciones[e].descripcion}</option>`;
                  }
                  
                  anotacionesList.innerHTML = options;
                }
              });

              opt_ame.addEventListener("change", (r) => {
                if (r.target.value !== "2") {
                  let establecimento_lim = { ...this.state.establecimiento };
                  establecimento_lim["id"] = "";
                  establecimento_lim["guid"] = "";
                  establecimento_lim["razon_social"] = "";

                  this.setState({ establecimento: establecimento_lim });
                  document.querySelector("#ameGuid").classList = "hide";
                  let ameid = document.querySelector("#ameid");
                  document.querySelector("#ame").classList = "";

                  Api.fetch(
                    "app/getEstablecimientosPorAnotacionMarginal?am_id=" +
                      r.target.value
                  ).then((establecimientos) => {
                    let opt_est = `<option value="">Seleccione establecimiento</option>`;
                    for (let e in establecimientos) {
                      opt_est += `<option value="${establecimientos[e].id}">
                          ${establecimientos[e].razon_social}
                          </option>`;
                    }
                    ameid.innerHTML = opt_est;
                  });
                } else {
                  document.querySelector("#ame").classList = "hide";
                  this.setState({ ame: "", disable_ame: false });

                  document.querySelector("#ameGuid").classList = "";
                  document.querySelector("#addEst").classList =
                    "form-control btn btn-light";
                  document.querySelector("#addEst i").classList = "fa fa-th";
                }

                // Verificar si existe orden de pago para esta anotación marginal
                if (r.target.value !== "") {
                  let tramite = {
                    tramite_id: "7",
                    anotacion_marginal_id: r.target.value,
                  };
                  this.ExisteOrdenPago(tramite, this.sol);
                }
              });
            } else if (me.value === "8") {
              //Anotacion marginal productos
              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento";
              this.sol.querySelector("#establecimiento").value = "";

              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              this.sol.hide([
                "tipo",
                "esNuevo",
                //"generarSol",
                "actividad",
                "tipoProducto",
                "tipoRegistro",
                "cantidad_precertificado",
                "reposicionLicRegente",
                //"establecimiento",
                "licencia_establecimiento",
                "productos",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "tipo_precertificado",
              ]);

              this.sol.hide("nombre_persona");
              this.forma_constancias.classList = "hide";
              btn_generar.classList = "hide";
              constancia_productos.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";

              /* */

              Api.fetch("app/getMyEstablishmentsAsRegent").then(
                (establecimientos) => {
                  let options = `<option value="">Seleccione establecimiento</option>`;
                  for (let e in establecimientos) {
                    options += `<option value="${establecimientos[e].id}">
                       ${establecimientos[e].razon_social}
                       </option>`;
                  }
                  document.querySelector("#establecimiento").innerHTML =
                    options;
                }
              );
            } else if (me.value === "9") {
              //Reposicion licencia regente

              /********* INICIO TRAMITE REPOSICION LIC REGENTE ********/
              Api.fetch("app/getLicenciasRegenteReposicion").then((data) => {
                if (data) {
                  let licRegente = data;
                  let comboLicencias =
                    '<option value="">Seleccione la licencia</option>';
                  for (let lic in licRegente) {
                    comboLicencias += `<option value="${
                      licRegente[lic].licencia_id
                    }">${
                      licRegente[lic].descripcion_t +
                      " " +
                      licRegente[lic].folio_licencia
                    }</option>`;
                  }
                  this.sol.querySelector("#reposicionLicRegente").innerHTML =
                    comboLicencias;
                }
              });
              /********* FIN TRAMITE REPOSICION LIC REGENTE********/

              this.sol.querySelector(".reposicionLicRegente").classList =
                "form-group reposicionLicRegente";
              this.sol.querySelector("#reposicionLicRegente").value = "";
              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              this.sol.hide([
                "esNuevo",
                "establecimiento",
                "tipo",
                "cantidad_precertificado",
                "actividad",
                "tipoProducto",
                "tipoRegistro",
                "nombre_persona",
                "licencia_establecimiento",
                "productos",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              this.sol.querySelector("#establecimiento").value = "";
              this.sol.querySelector("#licencia_establecimiento").value = "";

              medico.classList = "hide";
              constancia.classList = "hide";
              constancia_productos.classList = "hide";
              btn_generar.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
            } else if (me.value === "10") {
              //Reposicion licencia establecimiento

              /********* INICIO TRAMITE REPOSICIÓN LIC ESTABLECIMIENTOS - Trae lista de licencias de establecimientos del usuario ********/
              Api.fetch("app/getLicenciasEstablecimientosUser").then((data) => {
                if (data) {
                  let licEst = data;
                  let comboLicenciasEst =
                    '<option value="">Seleccione licencia</option>';
                  for (let lic in licEst) {
                    comboLicenciasEst += `<option value="${
                      licEst[lic].licencia_id
                    }">${
                      licEst[lic].descripcion_t +
                      " [" +
                      licEst[lic].folio_licencia +
                      "]"
                    }</option>`;
                  }
                  this.sol.querySelector(
                    "#licencia_establecimiento"
                  ).innerHTML = comboLicenciasEst;
                }
              });
              /********* FIN TRAMITE REPOSICIÓN LIC ESTABLECIMIENTOS ********/

              /*            sol.querySelector(".licencia_establecimiento").classList="form-group licencia_establecimiento";
                sol.querySelector("#licencia_establecimiento").value="";
                sol.querySelector(".generarSol").classList="form-group generarSol";
 */
              //Oculta y cambia valor: llegan al controlador vacio ("")
              this.sol.querySelector("#reposicionLicRegente").value = "";
              this.sol.querySelector("#establecimiento").value = "";
              //sol.querySelector(".licencia_establecimiento").classList="hide";
              this.sol.querySelector("#licencia_establecimiento").value = "";
              let options = `<option value="">Seleccione tipo de establecimiento</option>`;
              this.sol.querySelector("#tipo").innerHTML = options;

              this.sol.hide([
                "esNuevo",
                //"establecimiento",
                //"tipo",
                //"actividad",
                "nombre_persona",
                "tipoProducto",
                "cantidad_precertificado",
                "tipoRegistro",
                "reposicionLicRegente",
                "productos",
                "anotacion_marginal",
                "renovacion_establecimiento",
                "licencia_establecimiento",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              constancia.classList = "hide";
              constancia_productos.classList = "hide";
              medico.classList = "hide";
              btn_generar.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
              /****** *******/

              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento";
              this.sol.querySelector("#establecimiento").value = "";

              this.sol.querySelector(".tipo").classList = "form-group tipo";
              this.sol.querySelector("#tipo").value = "";

              this.sol.querySelector(".actividad").classList =
                "form-group actividad";
              this.sol.querySelector("#actividad").value = "";

              options = `<option value="">Seleccione establecimiento</option>`;
              this.sol.querySelector("#establecimiento").innerHTML = options;
              Api.fetch("app/getEstablecimientosRegRep").then((data) => {
                let establecimientos = data;
                for (let e in establecimientos) {
                  options += `<option value="${establecimientos[e].id}">
                        ${establecimientos[e].razon_social} - [${establecimientos[e].folio_establecimiento}]
                        </option>`;
                }
                this.sol.querySelector("#establecimiento").innerHTML = options;
              });

              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";
            } else if (me.value === "11") {
              //Refrenda producto
              this.limpiarForm_Refrenda();
              /* Ocultamos los elementos que no esten relacionados con la baja*/
              this.sol.hide([
                "productos",
                "tipo",
                "esNuevo",
                "generarSol",
                "nombre_persona",
                "actividad",
                "reposicionLicRegente",
                "establecimiento",
                "tipoProducto",
                "tipoRegistro",
                "licencia_establecimiento",
                "cantidad_precertificado",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              this.forma_constancias.classList = "hide";
              constancia_productos.classList = "hide";
              btn_generar.classList = "";
              /* */
              refrenda.classList = "hide";
              this.forma_Refrenda.classList = "";
              refreda_productos.classList = "";

              /** SE CARGA EL COMBO DE ESTABLECIMIENTOS TITULARES */
              let optionsT = `<option value="0">Seleccione el establecimiento titular</option>`;
              Api.fetch("app/getEstablecimientoTitularReg").then((data_est) => {
                if (data_est.length !== 0) {
                  for (let e in data_est) {
                    optionsT += `<option value="${data_est[e].id}"> ${data_est[e].razon_social} [${data_est[e].folio_establecimiento}] </option>`;
                  }
                } else {
                  //optionsT = `<option value="0">No tiene establecimientos titulares</option>`;
                }
                this.forma_Refrenda.querySelector("#titular").innerHTML =
                  optionsT;
              });
              /** FIN */
            } else if (me.value === "12") {
              //Baja establecimiento
              /* Ocultamos los elementos que no esten relacionados con la baja*/
              this.sol.hide([
                "tipo",
                "tipoRegistro",
                "tipoProducto",
                "esNuevo",
                "generarSol",
                "nombre_persona",
                "actividad",
                "reposicionLicRegente",
                "cantidad_precertificado",
                "establecimiento",
                "licencia_establecimiento",
                "productos",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              this.forma_constancias.classList = "hide";
              btn_generar.classList = "";
              constancia_productos.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
              /* */

              Api.fetch("app/getEstablecimientosRegRep").then((data) => {
                let establecimientos = data;
                let options = `<option value="">Seleccione establecimiento</option>`;
                for (let e in establecimientos) {
                  options += `<option value="${establecimientos[e].id}">
                        ${establecimientos[e].razon_social} - [${establecimientos[e].folio_establecimiento}]
                        </option>`;
                }
                document.querySelector("#baja_establecimiento_id").innerHTML =
                  options;
              });
            } else if (me.value === "13" || me.value === "25") {
              //Renovacion licencia establecimiento
              //sol.querySelector(".licencia_establecimiento").classList="form-group licencia_establecimiento";
              //sol.querySelector("#licencia_establecimiento").value="";

              /********* INICIO TRAMITE RENOVACION LIC ESTABLECIMIENTOS - Trae lista de licencias de establecimientos del usuario ******
                Api.fetch("app/getLicenciasEstablecimiento").then((data) => {
                  if (data) {
                    let licEst= data;
                    let comboLicenciasEst = '<option value="">Seleccione Licencia</option>';
                    for(let lic in licEst){
                      comboLicenciasEst += `<option value="${licEst[lic].licencia_id}">${licEst[lic].razon_social + " - " + licEst[lic].descripcion + " ["+ licEst[lic].folio_licencia + "]"}</option>`;
                    }
                    sol.querySelector("#licencia_establecimiento").innerHTML=comboLicenciasEst;
                  }
                });
                /********* FIN TRAMITE RENOVACION LIC ESTABLECIMIENTOS ********/
              Api.fetch("app/getLicenciasEstablecimientoRenovacion").then(
                (data) => {
                  if (data) {
                    let licEst = data;
                    let comboLicenciasEst =
                      '<option value="">Seleccione establecimiento</option>';
                    for (let lic in licEst) {
                      comboLicenciasEst += `<option value="${licEst[lic].id}">${
                        licEst[lic].razon_social +
                        " [" +
                        licEst[lic].folio_establecimiento +
                        "]"
                      }</option>`;
                    }
                    this.sol.querySelector("#establecimiento").innerHTML =
                      comboLicenciasEst;
                  }
                }
              );
              /***************** */
              /* Ocultamos los elementos que no esten relacionados con la renovacion de licencia establecimiento*/
              this.sol.hide([
                //"tipo",
                "esNuevo",
                //"actividad",
                "cantidad_precertificado",
                "reposicionLicRegente",
                //"establecimiento",
                "tipoProducto",
                "tipoRegistro",
                "productos",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "licencia_establecimiento",
                "tipo_precertificado",
              ]);
              this.sol.hide("nombre_persona");

              // sol.querySelector(".renovacion_establecimiento").classList="form-group renovacion_establecimiento";
              //sol.querySelector("#renovacion_establecimiento").value="";

              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento";
              this.sol.querySelector("#establecimiento").value = "";

              this.sol.querySelector(".tipo").classList = "form-group tipo";
              this.sol.querySelector("#tipo").value = "";

              this.sol.querySelector(".actividad").classList =
                "form-group actividad";
              this.sol.querySelector("#actividad").value = "";
              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              //medico.classList="hide";
              btn_generar.classList = "hide";
              constancia.classList = "hide";
              constancia_productos.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
            } else if (me.value === "14") {
              //Renovacion producto

              /********* INICIO TRAMITE RENOVACION PRODUCTOS - Trae lista de productos que tiene del usuario como regente ********/
              Api.fetch("app/getProductosRegenteRenovacion").then((data) => {
                if (data) {
                  let productos = data;
                  let comboListaProductos =
                    '<option value="">Seleccione producto</option>';
                  let tipo = [];
                  for (let prod in productos) {
                    comboListaProductos += `<option value="${
                      productos[prod].producto_id
                    }" 
                    data-tipo-producto="${productos[prod].tipo_producto_id}">${
                      productos[prod].nombre_comercial +
                      "(" +
                      productos[prod].no_registro +
                      ")"
                    }</option>`;
                    tipo.push({
                      tipo: productos[prod].tipo_producto_id,
                      producto: productos[prod].producto_id,
                    });
                  }

                  this.setState({ tipo_productos: tipo });
                  this.sol.querySelector("#productos").innerHTML =
                    comboListaProductos;
                }
              });
              /********* FIN TRAMITE RENOVACION PRODUCTOS ********/

              /* Ocultamos los elementos que no esten relacionados con la renovacion de producto*/
              this.sol.hide([
                "esNuevo",
                "establecimiento",
                "tipo",
                "cantidad_precertificado",
                "actividad",
                "generarSol",
                "tipoProducto",
                "tipoRegistro",
                "reposicionLicRegente",
                "licencia_establecimiento",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);
              
              this.sol.hide("nombre_persona");
              /* Mostramos el campode productos */

              this.sol.querySelector(".productos").classList =
                "form-group productos";
              this.sol.querySelector("#productos").value = "";
              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              constancia_productos.classList = "hide";
              constancia.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
              //medico.classList="hide";
              btn_generar.classList = "hide";
            } else if (me.value === "15") {
              //Baja producto
              /* Ocultamos los elementos que no esten relacionados con la baja de producto*/
              this.sol.hide([
                "esNuevo",
                "establecimiento",
                "tipo",
                "actividad",
                "nombre_persona",
                "generarSol",
                "tipoProducto",
                "cantidad_precertificado",
                "tipoRegistro",
                "reposicionLicRegente",
                "licencia_establecimiento",
                "anotacion_marginal",
                "tipo_certificado",
                "num_certificados",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);
              /* Mostramos el campode productos */

              Api.fetch("app/getProductosRegente").then((data) => {
                if (data) {
                  let productos = data;
                  let comboListaProductos =
                    '<option value="">Seleccione producto</option>';
                  for (let prod in productos) {
                    comboListaProductos += `<option value="${
                      productos[prod].producto_id
                    }">${
                      productos[prod].nombre_comercial +
                      "(" +
                      productos[prod].no_registro +
                      ")"
                    }</option>`;
                  }
                  this.sol.querySelector("#productos").innerHTML =
                    comboListaProductos;
                }
              });

              this.sol.querySelector(".productos").classList =
                "form-group productos";
              this.sol.querySelector("#productos").value = "";
              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              //medico.classList="hide";
              constancia_productos.classList = "hide";
              constancia.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
              btn_generar.classList = "hide";
            } else if (me.value === "17") {
              //Solicitud certificados
              /****** INICIO CAT TIPO CERTIFICADO *******/
              let tipo_certificado = Api.loadCatalogue("cat_tipo_certificado");
              let comboCertificado = `<option value="">Seleccione tipo de certificado</option>`;
              for (let tc in tipo_certificado) {
                comboCertificado += `<option value="${tipo_certificado[tc].id}">
                              ${tipo_certificado[tc].descripcion}
                      </option>`;
              }

              this.sol.querySelector("#tipo_certificado").innerHTML =
                comboCertificado;
              /****** FIN CAT TIPO CERTIFICADO *******/
              /* Ocultamos los elementos que no esten relacionados con certificados*/
              this.sol.hide([
                "esNuevo",
                "productos",
                "establecimiento",
                "tipo",
                "actividad",
                "generarSol",
                "tipoProducto",
                "nombre_persona",
                "tipoRegistro",
                "cantidad_precertificado",
                "reposicionLicRegente",
                "licencia_establecimiento",
                "anotacion_marginal",
                "tipo_precertificado",
                "num_certificados",
              ]);

              this.sol.querySelector(".tipo_certificado").classList =
                "form-group tipo_certificado";
              this.sol.querySelector("#tipo_certificado").value = "";

              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              //medico.classList="hide";

              constancia_productos.classList = "hide";
              constancia.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
              btn_generar.classList = "hide";
            } else if (me.value === "19") {
              //Solicitud certificados
              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento";
              this.sol.querySelector("#establecimiento").value = "";
              this.sol.querySelector(".cantidad_precertificado").classList =
                "form-group cantidad_precertificado";
              this.sol.querySelector("#cantidad_precertificado").value = "";
              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              this.sol.hide([
                "esNuevo",
                "productos",
                "tipo",
                "actividad",
                "tipoProducto",
                "nombre_persona",
                "tipoRegistro",
                "reposicionLicRegente",
                "licencia_establecimiento",
                "anotacion_marginal",
                "num_certificados",
                "tipo_precertificado",
              ]);

              //llenamos el campo de establecimientos
              Api.fetch("app/getEstablecimientosPrecertificadoCE").then(
                (establecimientos) => {
                  let options = `<option value="">Seleccione el establecimiento</option>`;
                  for (let e in establecimientos) {
                    options += `<option value="${establecimientos[e].id}">
                     ${establecimientos[e].razon_social} [${establecimientos[e].folio_establecimiento}]
                     </option>`;
                  }
                  this.sol.querySelector("#establecimiento").innerHTML =
                    options;
                }
              );

              constancia_productos.classList = "hide";
              constancia.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
              btn_generar.classList = "hide";
            } else if (me.value === "23") {
              //Solicitud Precertificados
              /****** INICIO CAT TIPO PRECERTIFICADO *******/
              let tipo_precertificado = Api.loadCatalogue(
                "cat_tipo_precertificado"
              );
              let comboPreCertificado = `<option value="">Seleccione tipo de precertificado</option>`;
              for (let tc in tipo_precertificado) {
                comboPreCertificado += `<option value="${tipo_precertificado[tc].id}">
                              ${tipo_precertificado[tc].descripcion}
                    </option>`;
              }
              this.sol.querySelector("#tipo_precertificado").innerHTML =
                comboPreCertificado;
              /****** FIN CAT TIPO PRECERTIFICADO *******/

              /* Ocultamos los elementos que no esten relacionados con certificados*/
              this.sol.hide([
                "esNuevo",
                "productos",
                "establecimiento",
                "tipo",
                "actividad",
                "generarSol",
                "tipoProducto",
                "tipoRegistro",
                "reposicionLicRegente",
                "licencia_establecimiento",
                "anotacion_marginal",
                "tipo_certificado",
              ]);

              this.sol.querySelector(".tipo_precertificado").classList =
                "form-group tipo_precertificado";
              this.sol.querySelector("#tipo_precertificado").value = "";

              //medico.classList="hide";

              constancia_productos.classList = "hide";
              constancia.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
              btn_generar.classList = "hide";
            } else if (data.tramite_id === "22") {
            } else if (data.tramite_id === "24") {
              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento";
              this.sol.querySelector("#establecimiento").value = "";
              this.sol.querySelector(".generarSol").classList =
                "form-group generarSol";

              /**yo regente o representante legal y el establecimiento tenga la actividad de
               * “Fabricante nacional de productos utilizados en alimentación animal“  id: 6*/
              let actividades = [12]; // fabricante nacional de subproducto de origen animal
              Api.fetch(
                "app/getEstablecimientosRepRegPorActividad",
                { actividades: actividades },
                "post"
              ).then((est) => {
                let options = `<option value="">Seleccione establecimiento</option>`;
                for (let e in est) {
                  options += `<option nacional="${est[e].nacional}" value="${est[e].id}">
                        ${est[e].razon_social} [${est[e].folio_establecimiento}]
                        </option>`;
                }
                this.sol.querySelector("#establecimiento").innerHTML = options;
              });

              this.sol.hide([
                "esNuevo",
                "tipo",
                "actividad",
                "nombre_persona",
                "tipoProducto",
                "tipoRegistro",
                "cantidad_precertificado",
                "reposicionLicRegente",
                "licencia_establecimiento",
                "anotacion_marginal",
                "tipo_certificado",
                "productos",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              medico.classList = "hide";
              //tablaEstablecimiento.classList="hide";
              btn_generar.classList = "hide";
              constancia.classList = "hide";
              constancia_productos.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
            } else {
              this.sol.hide([
                "esNuevo",
                "establecimiento",
                "tipo",
                "actividad",
                "generarSol",
                "nombre_persona",
                "tipoProducto",
                "tipoRegistro",
                "cantidad_precertificado",
                "reposicionLicRegente",
                "licencia_establecimiento",
                "anotacion_marginal",
                "tipo_certificado",
                "productos",
                "renovacion_establecimiento",
                "tipo_precertificado",
              ]);

              //medico.classList="hide";
              //tablaEstablecimiento.classList="hide";
              btn_generar.classList = "hide";
              constancia.classList = "hide";
              constancia_productos.classList = "hide";
              refrenda.classList = "hide";
              refreda_productos.classList = "hide";
            }

            if (
              me.value !== "3" &&
              me.value !== "4" &&
              me.value !== "6" &&
              me.value !== "7" &&
              me.value !== "8" &&
              me.value !== "14"
            ) {
              let tramite = {
                tramite_id: this.sol.querySelector("#tramite_id").value,
              };
              this.ExisteOrdenPago(tramite, this.sol);
            }
            break;

          case "esNuevo":
            let _tipos = this.sol.querySelector("#tipo").innerHTML;
            if (!(me.value * 1)) {
              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento";

              Api.fetch("app/getEstablecimientosRegRep").then((data) => {
                if (data) {
                  let est = [];
                  let establecimientos = data;
                  losestablecimientos = establecimientos;
                  let options = `<option value="">Seleccione establecimiento</option>`;
                  for (let e in establecimientos) {
                    options += `<option nacional="${establecimientos[e].nacional}" value="${establecimientos[e].id}">
                        ${establecimientos[e].razon_social} [${establecimientos[e].folio_establecimiento}]
                        </option>`;
                    est.push([
                      establecimientos[e].id,
                      establecimientos[e].nacional,
                    ]);
                  }
                  this.setState({
                    est_nacional: est,
                  });
                  this.sol.querySelector("#establecimiento").innerHTML =
                    options;
                  this.sol.querySelector("#establecimiento").onchange = (r) => {
                    let id = r.target.value;
                    let tpl = `<option value=""> ... Verificando tipos ... </option>`;
                    this.sol.querySelector("#tipo").innerHTML = tpl;

                    Api.fetch("app/verificaRegencia?id=" + id).then((r) => {
                      tpl = `<option value="">Seleccione...</option>`;
                      for (let tipos in r) {
                        tpl += `<option value="${r[tipos].id}">${r[tipos].descripcion}</option>`;
                      }
                      this.sol.querySelector("#tipo").innerHTML = tpl;
                    });
                  };
                }
              });
            } else {
              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento hide";
              this.sol.querySelector("#establecimiento").value = "";

              this.sol.querySelector("#tipo").innerHTML = _tipos;

              /*//Regresar tipos de establecimientos a su estado original.
                let el = sol.querySelectorAll("option.hide");
                for(let e in el){
                  if(el[e].classList){
                    el[e].classList=el[e].classList.toString().replace("hide","");
                  }*/
              //}
            }

            break;

          case "establecimiento":
            if (this.state.tramite_id === "8") {
              this.sol.querySelector(".productos").classList =
                "form-group productos";
              this.sol.querySelector("#productos").value = "";

              Api.fetch(
                "app/getTodosProductosEstablecimiento?establecimiento_id=" +
                  me.value
              ).then((data) => {
                if (data) {
                  let productos = data;
                  let comboListaProductos =
                    '<option value="">Seleccione producto</option>';
                  for (let prod in productos) {
                    comboListaProductos += `<option value="${
                      productos[prod].id
                    }">${
                      productos[prod].nombre_comercial +
                      "(" +
                      productos[prod].no_registro +
                      ")"
                    }</option>`;
                  }
                  this.sol.querySelector("#productos").innerHTML =
                    comboListaProductos;
                }
              });
            } else if (this.state.tramite_id === "3") {
              for (let est in losestablecimientos) {
                if (losestablecimientos[est].id === me.value) {
                  if (losestablecimientos[est].pais_texto === null) {
                    let el = this.sol.querySelectorAll(".n-0");
                    for (let e in el) {
                      if (el[e].classList) {
                        el[e].classList = "hide n-0";
                      }
                    }

                    el = this.sol.querySelectorAll(".n-1");
                    for (let e in el) {
                      if (el[e].classList) {
                        el[e].classList = "n-1";
                      }
                    }

                    /*let options = `<option value="">Seleccione tipo de establecimiento</option>`;
                         for (let tipo in tipoEstablecimiento){
                           if(tipoEstablecimiento[tipo].id === "1" || tipoEstablecimiento[tipo].id === "3"){
                             options+=`<option className="n-${tipoEstablecimiento[tipo].nacional} otipo" value="${tipoEstablecimiento[tipo].id}">
                             ${tipoEstablecimiento[tipo].descripcion}
                             </option>`;
                         }
                         sol.querySelector("#tipo").innerHTML=options;
                         */
                    //  }
                  } else {
                    let el = this.sol.querySelectorAll(".n-1");
                    for (let e in el) {
                      if (el[e].classList) {
                        el[e].classList = "hide n-1";
                      }
                    }
                    el = this.sol.querySelectorAll(".n-0");
                    for (let e in el) {
                      if (el[e].classList) {
                        el[e].classList = "n-0";
                      }
                    }

                    let options = `<option value="">Seleccione tipo de establecimiento</option>`;
                    for (let tipo in tipoEstablecimiento) {
                      if (
                        tipoEstablecimiento[tipo].id === "2" ||
                        tipoEstablecimiento[tipo].id === "4"
                      ) {
                        options += `<option className="n-${tipoEstablecimiento[tipo].nacional} otipo" value="${tipoEstablecimiento[tipo].id}">
                             ${tipoEstablecimiento[tipo].descripcion}
                             </option>`;
                      }
                      this.sol.querySelector("#tipo").innerHTML = options;
                    }
                  }
                }
              }
            } else if (this.state.tramite_id === "10") {
              Api.fetch(
                "app/getTiposDelEstablecimiento?establecimiento_id=" + me.value
              ).then((data) => {
                let tipo = data;
                let options = `<option value="">Seleccione el tipo de establecimiento</option>`;
                for (let e in tipo) {
                  options += `<option value="${tipo[e].id}">
                      ${tipo[e].descripcion}
                      </option>`;
                }
                this.sol.querySelector("#tipo").innerHTML = options;
              });

              let options_activities = `<option value="">Seleccione actividad de licencia</option>`;
              this.sol.querySelector("#actividad").innerHTML =
                options_activities;
            } else if (this.state.tramite_id === "13" || this.state.tramite_id === "25") {
              //let e_id = sol.querySelector("#establecimiento").value;
              Api.fetch(
                "app/getTipoEstablecimientoRenovacion?establecimiento_id=" +
                  me.value
              ).then((data) => {
                let tipo = data;
                let options = `<option value="">Seleccione el tipo de establecimiento</option>`;
                for (let e in tipo) {
                  options += `<option value="${tipo[e].id}">
                      ${tipo[e].descripcion}
                      </option>`;
                }
                this.sol.querySelector("#tipo").innerHTML = options;
              });
            } else {
              let est_nacional = this.state.est_nacional;
              let nacional = "";

              for (let e in est_nacional) {
                if (est_nacional[e][0] === me.value) {
                  nacional = est_nacional[e][1];
                  break;
                }
              }

              let tipoEstablecimiento = Api.loadCatalogue(
                "cat_tipo_establecimiento"
              );

              let options = `<option value="">Seleccione tipo de establecimiento</option>`;
              for (let tipo in tipoEstablecimiento) {
                if (tipoEstablecimiento[tipo].nacional === nacional) {
                  options += `<option className="n-${tipoEstablecimiento[tipo].nacional} otipo" value="${tipoEstablecimiento[tipo].id}">
                  ${tipoEstablecimiento[tipo].descripcion}
                  </option>`;
                }
              }
              this.sol.querySelector("#tipo").innerHTML = options;
            }
            break;

          case "tipo":
            if (this.state.tramite_id === "3") {
              this.sol.hide("nombre_persona");

              let e_id = this.sol.querySelector("#establecimiento").value;
              Api.fetch(
                "app/getEstablishmentsActivities?tipo_establecimiento=" +
                  me.value +
                  "&est_id=" +
                  e_id
              ).then((data) => {
                if (data) {
                  let tipoActividades = data.actividades;

                  let options = `<option value="">Seleccione actividad</option>`;
                  for (let tipo in tipoActividades) {
                    options += `<option value="${tipoActividades[tipo].id}">
                        ${tipoActividades[tipo].descripcion}
                        </option>`;
                  }
                  this.sol.querySelector("#actividad").innerHTML = options;
                  //this.setState({ options_activities: data.actividades });
                }
              });
            } else if (this.state.tramite_id === "10") {
              let e_id = this.sol.querySelector("#establecimiento").value;
              Api.fetch(
                "app/getLicenciasConActividadEstablecimiento?establecimiento_id=" +
                  e_id +
                  "&tipo=" +
                  me.value
              ).then((data) => {
                let licencias = data;
                let options = `<option value="">Seleccione actividad de licencia</option>`;
                for (let e in licencias) {
                  options += `<option value="${licencias[e].id}">
                      ${licencias[e].descripcion}  [${licencias[e].folio_licencia}]
                      </option>`;
                }
                this.sol.querySelector("#actividad").innerHTML = options;
              });
            } else if (this.state.tramite_id === "13" || this.state.tramite_id === "25") {
              let e_id = this.sol.querySelector("#establecimiento").value;
              Api.fetch(
                "app/getActividadesRenovacion?establecimiento_id=" +
                  e_id +
                  "&tipo=" +
                  me.value
              ).then((data) => {
                let licencias = data;
                let options = `<option value="">Seleccione actividad de licencia</option>`;
                for (let e in licencias) {
                  options += `<option value="${licencias[e].actividad_id}">
                      ${licencias[e].descripcion}  [${licencias[e].folio_licencia}]
                      </option>`;
                }
                this.sol.querySelector("#actividad").innerHTML = options;
              });
            }

            break;

          case "tipoProducto":
            this.sol.hide("nombre_persona");

            if (me.value !== "") {
              Api.fetch(
                "app/getEstablecimientosTipoProducto?tipo_producto=" + me.value
              ).then((data) => {
                if (data) {
                  let establecimientos = data;
                  losestablecimientos = establecimientos;
                  let options = `<option value="">Seleccione establecimiento</option>`;
                  for (let e in establecimientos) {
                    options += `<option value="${establecimientos[e].id}">
                        ${establecimientos[e].razon_social} [${establecimientos[e].folio_establecimiento}]
                        </option>`;
                  }
                  this.sol.querySelector("#establecimiento").innerHTML =
                    options;
                }
              });

              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento";

              Api.fetch(
                "app/getRegistroTipoProducto?tipo_producto=" + me.value
              ).then((data) => {
                if (data) {
                  let registros = data;
                  let comboRegistro = `<option value="">Seleccione registro</option>`;
                  for (let registro in registros) {
                    comboRegistro += `<option value="${registros[registro].id}">
                                 ${registros[registro].descripcion}
                        </option>`;
                  }
                  this.sol.querySelector("#tipoRegistro").innerHTML =
                    comboRegistro;
                }
              });

              if (this.sol.querySelector("#tramite_id").value === "4") {
                let tramite = {
                  tramite_id: this.sol.querySelector("#tramite_id").value,
                  tipo_id: me.value,
                };

                this.ExisteOrdenPago(tramite, this.sol);
              }
            } else {
              this.sol.querySelector(".establecimiento").classList =
                "form-group establecimiento hide";
              this.sol.querySelector("#establecimiento").value = "";
              this.sol.hide("nombre_persona");
            }

            break;

          case "productos":
            if (this.state.tramite_id === "8") {
              Api.fetch(
                "app/getAnotacionesPorTipoProducto?producto_id=" + me.value
              ).then((data) => {
                if (data) {
                  let anotacion_registros = data;
                  let comboAnotacionRegistro = `<option value="">Seleccione anotación marginal</option>`;
                  for (let registro in anotacion_registros) {
                    comboAnotacionRegistro += `<option value="${anotacion_registros[registro].id}">
                               ${anotacion_registros[registro].descripcion}
                      </option>`;
                  }
                  this.sol.querySelector("#anotacion_marginal").innerHTML =
                    comboAnotacionRegistro;
                }
              });

              this.sol.querySelector(".anotacion_marginal").classList =
                "form-group anotacion_marginal";
              this.sol.querySelector("#anotacion_marginal").value = "";
            }

            if (this.state.tramite_id === "14") {
              this.state.tipo_productos.forEach((pro) => {
                if (pro.producto === me.value) {
                  this.setState({ tipo_producto_id: pro.tipo });
                }
              });

              let tramite = {
                tramite_id: this.state.tramite_id,
                tipo_id: this.state.tipo_producto_id,
              };
              this.ExisteOrdenPago(tramite, this.sol);
            }
            break;

          case "tipo_certificado":
            //si es tipo de certificado clv preguntamos el numero de certificados a pagar
            //if(me.value === "1"){
            this.sol.querySelector(".num_certificados").classList =
              "form-group num_certificados";
            this.sol.querySelector("#num_certificados").value = "";
            /*  }else{ //default para cee
                this.sol.querySelector(".num_certificados").classList="form-group num_certificados hide";
                this.sol.querySelector("#num_certificados").value="1";
              } */

            //buscamos mis establecimientos como regente. Depende del tipo de certificado son los disponibles
            Api.fetch(
              "app/getMyEstablishmentsAsRegentforCertificates?tipo_certificado_id=" +
                me.value
            ).then((establecimientos) => {
              let options = `<option value="">Seleccione establecimiento</option>`;
              for (let e in establecimientos) {
                options += `<option value="${establecimientos[e].id}">
                        ${establecimientos[e].razon_social}
                        </option>`;
              }
              document.querySelector("#establecimiento").innerHTML = options;
            });

            this.sol.querySelector(".establecimiento").classList =
              "form-group establecimiento";
            this.sol.querySelector("#establecimiento").value = "";

            break;

          case "actividad":
            let tramite_id = this.sol.querySelector("#tramite_id").value;
            //let tramite = {};

            if (tramite_id === "3") {
              let v_tipo = this.sol.querySelector("#tipo").value;

              let tramite = {
                tramite_id: tramite_id,
                tipo_id: v_tipo,
                act_id: me.value,
              };

              this.ExisteOrdenPago(tramite, this.sol);
            }

            break;

          case "anotacion_marginal":
            //let tramite_id =  this.sol.querySelector("#tramite_id").value;
            //let tramite = {};

            if (this.sol.querySelector("#tramite_id").value === "8") {
              let tramite = {
                tramite_id: this.sol.querySelector("#tramite_id").value,
                anotacion_marginal_id: me.value,
              };

              this.ExisteOrdenPago(tramite, this.sol);
            }

            break;
          case "tipo_precertificado":
            let precertificado = { ...this.state.precertificado };
            precertificado["tipo_precertificado"] = me.value;
            this.setState({
              tipo_precertificado: me.value,
              precertificado: precertificado,
            });
            document.querySelector("#btn_generar").classList = "";
            break;
          default:
            break;
        }
      },
      render: (me) => {
        Api.loading(true);
        Api.fetch("app/tramitePorUsuario").then((tramites) => {
          let comboTramite = `<option value="">Seleccione trámite</option>`;
          for (let t in tramites) {
            comboTramite += `<option value="${tramites[t].id}">${tramites[t].descripcion}</option>`;
          }
          me.querySelector("#tramite_id").innerHTML = comboTramite;
          Api.loading(0);
        });

        let options = `<option value="">Seleccione establecimiento</option>`;
        options = `<option value="">Seleccione actividad</option>`;
        me.querySelector("#actividad").innerHTML = options;

        //Api.loading(0);
      },
    };

    this.sol = Api.form(solicitud_orden);

    this.forma_constancias = Api.form({
      target: "#f_constancias",
      class: "constancias",
      elementClass: "form-control",
      elements: [
        {
          select: {
            name: "constancia_tipo_id",
            label: "Tipo de constancia",
            placeHolder: "Seleccione",
            cols: 6,
          },
        },
        {
          input: {
            name: "nombre_persona",
            label: "Orden a nombre de",
            cols: 6,
            hide: true,
            placeHolder: "Nombre completo",
            type: "text",
            onkeyup: "this.value = this.value.toUpperCase();",
          },
        },
        {
          select: {
            name: "regente_tipo_id",
            label: "Tipo de regente",
            regente_id: "",
            placeHolder: "Seleccione",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "establecimiento_id",
            label: "Establecimiento",
            placeHolder: "Seleccione",
            value: "0",
            cols: 12,
            hide: true,
          },
        },
        {
          select: {
            name: "actividad_id",
            label: "Actividad",
            placeHolder: "Seleccione",
            value: "0",
            cols: 12,
            hide: true,
          },
        },
        {
          textarea: {
            name: "peticion",
            cols: 12,
            rows: 5,
            label: "Ingrese petición:",
            maxLength: this.state.peticionMaxLen,
            hide: true,
            onChange: (e) => {},
          },
        },
      ],
      onchange: (me, data, serial) => {
        switch (me.name) {
          case "regente_tipo_id":
            let regente_tipo_id =
              constancia.querySelector("#regente_tipo_id").value;

            Api.fetch("app/getDataRegEst?tipo_id="+regente_tipo_id).then((data) => {
              let optionsEst = `<option value="0">Seleccione establecimiento</option>`;
              if (data) {
                for (let e in data) {
                  optionsEst += `<option value="${data[e].id}"> ${data[e].razon_social} [${data[e].folio_establecimiento}]</option>`;
                }
              }
              constancia.querySelector("#establecimiento_id").innerHTML =
                optionsEst;
            });
            break;

          case "establecimiento_id":
            let constancia_tipo_id = constancia.querySelector(
              "#constancia_tipo_id"
            ).value;
            let establecimiento_id = me.value;

            let vacio = [];
            this.setState({ productos: vacio });

            if (constancia_tipo_id === "4") {
              Api.fetch(
                "app/getActividadesEstablecimiento?establecimiento_id=" +
                  establecimiento_id
              ).then((data) => {
                if (data) {
                  let actividad = data;
                  let options = `<option value="0">Seleccione actividad</option>`;
                  for (let a in actividad) {
                    options += `<option value="${actividad[a].id}"> ${actividad[a].descripcion} </option>`;
                  }
                  constancia.querySelector("#actividad_id").innerHTML = options;
                }
              });
            } else if (
              constancia_tipo_id === "6" ||
              constancia_tipo_id === "7"
            ) {
              let tipo_producto =
                constancia_tipo_id === "6" ? [5] : [1, 2, 3, 4];
              Api.fetch(
                "app/getProductosEstablecimientoTipo",
                {
                  establecimiento_id: establecimiento_id,
                  tipo_producto: tipo_producto,
                },
                "post"
              ).then((data) => {
                if (data) {
                  this.setState({
                    options_productos: data,
                  });
                }
              });
            } else if (constancia_tipo_id === "8") {
              Api.fetch(
                "app/getProductosConstanciaAM?establecimiento_id=" +
                  establecimiento_id
              ).then((data) => {
                if (data) {
                  this.setState({
                    options_productos: data,
                  });
                }
              });
            } else if (
              constancia_tipo_id === "8" ||
              constancia_tipo_id === "10" ||
              constancia_tipo_id === "11"
            ) {
              Api.fetch(
                "app/getTodosProductosEstablecimiento?establecimiento_id=" +
                  establecimiento_id
              ).then((data) => {
                if (data) {
                  this.setState({
                    options_productos: data,
                  });
                }
              });
            }
            break;

          case "constancia_tipo_id":
            this.limpiarForm();

            let textoLibre = [1, 2, 3, 12];
            let tipo_id = me.value;
            let encuentra_tl = textoLibre.includes(parseInt(tipo_id));

            if (encuentra_tl) {
              constancia.querySelector(".peticion").classList =
                "form-group peticion";

              //ocultar
              constancia.querySelector(".establecimiento_id").classList =
                "form-group establecimiento_id hide";
              constancia.querySelector(".regente_tipo_id").classList =
                "form-group regente_tipo_id hide";
              constancia.querySelector(".actividad_id").classList =
                "form-group actividad_id hide";
              constancia_productos.classList = "hide";
            } else {
              constancia.querySelector(".establecimiento_id").classList =
                "form-group establecimiento_id";

              if (tipo_id === "5") {
                constancia.querySelector(".regente_tipo_id").classList =
                   "form-group regente_tipo_id";

                Api.fetch("app/getTipoRegente").then((data) => {
                   let options = `<option value="0" regente_id="">Seleccione el tipo de regente</option>`;
                   if (data) {
                     for (let tipo in data) {
                       options += `<option value="${data[tipo].id}" regente_id="${data[tipo].regente_id}">${data[tipo].descripcion}</option>`;
                     }
                   }
                   constancia.querySelector("#regente_tipo_id").innerHTML =
                     options;
                 });

                constancia.querySelector(".actividad_id").classList =
                  "form-group actividad_id hide";
                constancia_productos.classList = "hide";

                /**
                 * Solo cuando el tipo de constancia es constancia de registro regente
                 */

               /*  if (tipo_id === "5") {
                  Api.fetch("app/getDataRegEst").then((data) => {
                    let optionsEst = `<option value="0">Seleccione establecimiento</option>`;
                    if (data) {
                      for (let e in data) {
                        optionsEst += `<option value="${data[e].id}"> ${data[e].razon_social} [${data[e].folio_establecimiento}]</option>`;
                      }
                    }
                    constancia.querySelector("#establecimiento_id").innerHTML =
                      optionsEst;
                  });
                } */
              } else if (tipo_id === "4") {
                constancia.querySelector(".actividad_id").classList =
                  "form-group actividad_id";

                Api.fetch("app/getEstablecimientosRegRep").then((data) => {
                  if (data) {
                    let establecimientos = data;
                    let options = `<option value="0">Seleccione establecimiento</option>`;
                    for (let e in establecimientos) {
                      options += `<option value="${establecimientos[e].id}">
                      ${establecimientos[e].razon_social} [${establecimientos[e].folio_establecimiento}]
                      </option>`;
                    }
                    constancia.querySelector("#establecimiento_id").innerHTML =
                      options;
                  }
                });

                //constancia.querySelector(".establecimiento_id").classList="col-sm-12"; //no jala
                //document.querySelector(".establecimiento_id").classList="form-group col-lg-12";
                //document.querySelector(".form-group establecimiento_id").classList="form-group col-lg-12";//classList de null
                //constancia.querySelector(".establecimiento_id").classList="form-group col-lg-12"; //no jala
                //constancia.querySelector(".regente_tipo_id").style.display = "none";//no quita el espacio
                //document.querySelector(".regente_tipo_id").style.display = "none";//no quita el espacio
                //constancia.querySelector(".regente_tipo_id").classList="col-sm-0"; //tampoco funciona

                //ocultar
                constancia.querySelector(".regente_tipo_id").classList =
                  "form-group regente_tipo_id hide";
                constancia_productos.classList = "hide";
              } else if (tipo_id === "6") {
                constancia_productos.classList = "";

                Api.fetch("app/getEstablecimientosConstanciaAA").then(
                  (data) => {
                    if (data) {
                      let establecimientos = data;
                      let options = `<option value="0">Seleccione establecimiento</option>`;
                      for (let e in establecimientos) {
                        options += `<option value="${establecimientos[e].id}">
                      ${establecimientos[e].razon_social} [${establecimientos[e].folio_establecimiento}]
                      </option>`;
                      }
                      constancia.querySelector(
                        "#establecimiento_id"
                      ).innerHTML = options;
                    }
                  }
                );

                constancia.querySelector(".actividad_id").classList =
                  "form-group actividad_id hide";
                constancia.querySelector(".regente_tipo_id").classList =
                  "form-group regente_tipo_id hide";
              } else if (tipo_id === "7") {
                constancia_productos.classList = "";

                Api.fetch("app/getEstablecimientosConstanciaMV").then(
                  (data) => {
                    if (data) {
                      let establecimientos = data;
                      let options = `<option value="0">Seleccione establecimiento</option>`;
                      for (let e in establecimientos) {
                        options += `<option value="${establecimientos[e].id}">
                      ${establecimientos[e].razon_social} [${establecimientos[e].folio_establecimiento}]
                      </option>`;
                      }
                      constancia.querySelector(
                        "#establecimiento_id"
                      ).innerHTML = options;
                    }
                  }
                );

                constancia.querySelector(".actividad_id").classList =
                  "form-group actividad_id hide";
                constancia.querySelector(".regente_tipo_id").classList =
                  "form-group regente_tipo_id hide";
              } else if (tipo_id === "8") {
                constancia_productos.classList = "";

                this.handleEstablecimientosRepRegTitularesFabricantes();

                constancia.querySelector(".actividad_id").classList =
                  "form-group actividad_id hide";
                constancia.querySelector(".regente_tipo_id").classList =
                  "form-group regente_tipo_id hide";
              } else if (tipo_id === "9") {
                Api.fetch(
                  "app/getEstablecimientosConstanciaRepresentanteLegal"
                ).then((data) => {
                  if (data) {
                    let establecimientos = data.establecimientos;
                    let options = `<option value="0">Seleccione establecimiento</option>`;
                    for (let e in establecimientos) {
                      options += `<option value="${establecimientos[e].id}">
                      ${establecimientos[e].razon_social} [${establecimientos[e].folio_establecimiento}]
                      </option>`;
                    }
                    constancia.querySelector("#establecimiento_id").innerHTML =
                      options;

                    this.setState({ representante_nom: data.representante });
                  }
                });

                constancia_productos.classList = "hide";
                constancia.querySelector(".actividad_id").classList =
                  "form-group actividad_id hide";
                constancia.querySelector(".regente_tipo_id").classList =
                  "form-group regente_tipo_id hide";
              } else if (tipo_id === "10" || tipo_id === "11") {
                constancia_productos.classList = "";

                this.handleEstablecimientosRepRegTitularesFabricantes();
                constancia.querySelector(".actividad_id").classList =
                  "form-group actividad_id hide";
                constancia.querySelector(".regente_tipo_id").classList =
                  "form-group regente_tipo_id hide";
              } else {
                constancia.querySelector(".establecimiento_id").classList =
                  "form-group establecimiento_id hide";
                constancia.querySelector(".regente_tipo_id").classList =
                  "form-group regente_tipo_id hide";
                constancia.querySelector(".actividad_id").classList =
                  "form-group actividad_id hide";
                constancia_productos.classList = "hide";
              }

              //ocultar
              constancia.querySelector(".peticion").classList =
                "form-group peticion hide";
            }

            if (tipo_id !== "0") {
              let tramite = {
                tramite_id: this.sol.querySelector("#tramite_id").value,
                tipo_id: tipo_id,
              };

              this.ExisteOrdenPago(tramite, this.forma_constancias);
            }

            break;

          default:
            break;
        }
      },
      render: (me) => {
        let tipoConstancia = Api.loadCatalogue("cat_constancia_tipo");

        let optionsEst = `<option value="0">Seleccione establecimiento</option>`;
        me.querySelector("#establecimiento_id").innerHTML = optionsEst;

        let optionsAct = `<option value="0">Seleccione actividad</option>`;
        me.querySelector("#actividad_id").innerHTML = optionsAct;

        let optionReg = `<option value="0" regente_id="">Seleccione el tipo de regente</option>`;
        me.querySelector("#regente_tipo_id").innerHTML = optionReg;

        let options = `<option value="0">Seleccione el tipo de constancia</option>`;
        for (let tipo in tipoConstancia) {
          options += `<option value="${tipoConstancia[tipo].id}">${tipoConstancia[tipo].descripcion}</option>`;
        }
        me.querySelector("#constancia_tipo_id").innerHTML = options;

        me.querySelector("#peticion").value = " ";
      },
    });

    this.forma_Refrenda = Api.form({
      target: "#f_refrenda",
      class: "",
      elementClass: "form-control",
      elements: [
        {
          select: {
            name: "titular",
            label: "Titular",
            value: "0",
            cols: 12,
          },
        },
        {
          select: {
            name: "fabricante",
            label: "Fabricante",
            value: "0",
            cols: 6,
          },
        },
        {
          select: {
            name: "pais",
            label: "País de origen",
            value: "0",
            cols: 6,
          },
        },
      ],
      onchange: (me, data, serial) => {
        const titular = refrenda.querySelector("#titular").value;
        const fabricante = refrenda.querySelector("#fabricante").value;

        switch (me.name) {
          case "titular":
            /**limpio */
            let options = ``;
            refrenda.querySelector("#fabricante").value = "0";
            options = `<option value="0">Seleccione el establecimiento fabricante</option>`;
            refrenda.querySelector("#fabricante").innerHTML = options;

            refrenda.querySelector("#pais").value = "0";
            options = `<option value="0">seleccione el país de origen</option>`;
            refrenda.querySelector("#pais").innerHTML = options;

            this.setState({ productos_refrenda: [] });
            /**fin */

            let optionsF = `<option value="0">Seleccione el establecimiento fabricante</option>`;
            Api.fetch(
              "app/getEstablecimientoFabricante?establecimiento_id=" + me.value
            ).then((data_est) => {
              if (data_est.length !== 0) {
                for (let e in data_est) {
                  optionsF += `<option value="${data_est[e].id}"> ${data_est[e].razon_social} [${data_est[e].folio_establecimiento}] </option>`;
                }
              } else {
                // optionsF = `<option value="0">No tiene establecimientos Fabricante</option>`;
              }
              refrenda.querySelector("#fabricante").innerHTML = optionsF;
            });

            break;

          case "fabricante":
            let optionsP = `<option value="0">seleccione el país de origen</option>`;
            Api.fetch(
              "app/getPaisProductoRefrenda?titular=" +
                titular +
                "&fabricante=" +
                me.value
            ).then((data_p) => {
              if (data_p.length !== 0) {
                for (let e in data_p) {
                  optionsP += `<option value="${data_p[e].id}"> ${data_p[e].descripcion} </option>`;
                }
              } else {
                //optionsP = `<option value="0">No tiene establecimientos Fabricante</option>`;
              }
              refrenda.querySelector("#pais").innerHTML = optionsP;
            });
            break;

          case "pais":
            this.setState({ productos_refrenda: [] });

            Api.fetch(
              "app/getProductoRefrenda?titular=" +
                titular +
                "&fabricante=" +
                fabricante +
                "&pais=" +
                me.value
            ).then((data_p) => {
              if (data_p.length !== 0) {
                this.setState({ options_productos_refrenda: data_p });
              }
            });
            break;

          default:
            break;
        }
      },
      render: (me) => {
        let optionsT = `<option value="0">Seleccione el establecimiento titular</option>`;
        refrenda.querySelector("#titular").innerHTML = optionsT;

        let optionsF = `<option value="0">Seleccione el establecimiento fabricante</option>`;
        refrenda.querySelector("#fabricante").innerHTML = optionsF;

        let optionsP = `<option value="0">seleccione el país de origen</option>`;
        refrenda.querySelector("#pais").innerHTML = optionsP;
      },
    });

    this.btn_generar = Api.form({
      target: "#btn_generar",
      class: "",
      elementClass: "form-control",
      elements: [
        {
          button: {
            name: "btn_generarSol",
            class: "form-control btn btn-lg btn-primary",
            cols: 12,
            text: "Generar",
            click: (me, data) => {
              let tramite_id = this.sol.data().tramite_id;

              if (tramite_id === "6") {
                let constancia_data = this.forma_constancias.data();

                let obj_enviar = {
                  tramite_id: tramite_id,
                  cons_tipo_id: constancia_data.constancia_tipo_id,
                  cons_texto: constancia_data.peticion,
                  est_id: constancia_data.establecimiento_id,
                  act_id: constancia_data.actividad_id,
                  reg_tipo_id: constancia_data.regente_tipo_id,
                  productos: this.state.productos,
                  representante: this.state.representante_nom,
                  nombre_persona: constancia_data.nombre_persona,
                  existe_orden: this.state.existe_orden,
                };
                this.validarFormConstancia(obj_enviar);
              } else if (tramite_id === "7") {
                let tipo = document.querySelector("#anotaciones").value;
                let establecimento = "";
                if (tipo !== "2") {
                  establecimento = document.querySelector("#ameid").value;
                } else {
                  establecimento = this.state.establecimiento["id"];
                }

                let nombre_persona =
                  document.querySelector("#nombre_persona").value;
                let valido = 1;

                if (establecimento === "") {
                  this.mensajeError(
                    "Error",
                    "Favor de asignar el establecimiento"
                  );
                  valido = 0;
                }

                if (tipo === "") {
                  this.mensajeError(
                    "Error",
                    "Favor de seleccionar el tipo de anotación"
                  );
                  valido = 0;
                }

                if (
                  this.state.existe_orden === true &&
                  (nombre_persona === "" || nombre_persona === undefined)
                ) {
                  this.mensajeError(
                    "Error",
                    "Ingrese a nombre de quien va a estar la orden de pago."
                  );
                  valido = 0;
                }

                if (valido) {
                  Swal.fire({
                    title: "Solicitar anotación marginal a establecimiento",
                    text: "¿está seguro?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Regresar",
                    reverseButtons: true,
                    cancelButtonColor: "Red",
                    confirmButtonColor: "#4CD964",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      Api.loading(1);
                      Api.fetch(
                        "app/generarOrdenPagoAME",
                        {
                          establecimiento_id: establecimento,
                          tramite_id: 7,
                          tipo: tipo,
                          nombre_persona: nombre_persona,
                          existe_orden: this.state.existe_orden,
                        },
                        "POST"
                      ).then((data) => {
                        Api.loading(0);

                        Swal.fire({
                          title: "Orden generada",
                          icon: "success",
                          message: data.message,
                          confirmButtonText: "Continuar",
                        }).then(function () {
                          window.location.href = "/tramites";
                        });
                      });
                    }
                  });
                }
              } else if (tramite_id === "22") {
                // Casos especiales
                this.handleCasoEspecial();
              } else if (tramite_id === "12") {
                this.handleBajaEstablecimiento();
              } else if (tramite_id === "11") {
                let refrenda = this.forma_Refrenda.data();
                let nombre_persona =
                  document.querySelector("#nombre_persona").value;

                let obj_enviar = {
                  tramite_id: tramite_id,
                  titular_id: refrenda.titular,
                  fabricate_id: refrenda.fabricante,
                  pais_id: refrenda.pais,
                  productos: this.state.productos_refrenda,
                  nombre_persona: nombre_persona,
                  existe_orden: this.state.existe_orden,
                };

                this.validarFormRefrenda(obj_enviar);
              } else if (tramite_id === "23") {
                this.handlePreCertificadoProducto();
              }
            },
          },
        },
      ],
    });
  }

  ExisteOrdenPago = (tramite, forma) => {
    Api.loading(true);
    Api.fetch("app/existeOrdenPago", tramite, "post").then((existe) => {
      if (existe) {
        forma.querySelector(".nombre_persona").classList =
          "form-group nombre_persona";
        forma.querySelector("#nombre_persona").value = "";

        this.setState({ existe_orden: true });
      } else {
        forma.hide("nombre_persona");
      }

      Api.loading(false);
    });
  };

  handleAnotacionMarginalEstablecimiento() {
    Swal.fire({
      title: "Solicitar anotación marginal a establecimiento",
      text: "¿Está seguro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(1);
        let establecimento = document.querySelector("#ameid").value;
        let tipo = document.querySelector("#anotaciones").value;
        let nombre_persona = document.querySelector("#nombre_persona").value;
        Api.fetch(
          "app/generarOrdenPagoAME",
          {
            establecimiento_id: establecimento,
            tramite_id: 7,
            tipo: tipo,
            nombre_persona: nombre_persona,
            existe_orden: this.state.existe_orden,
          },
          "POST"
        ).then((data) => {
          Api.loading(0);
          Swal.fire({
            title: "Solicitud exitosa",
            icon: "success",
            text: data.message,
          }).then(() => {
            // window.location = "/tramites";
          });
        });
      }
    });
  }
  handleCasoEspecial() {
    Swal.fire({
      title: "Casos Especiales",
      text: "¿Seguro que desea enviar la solicitud de caso especial?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/generarOrdenPagoEstablecimiento",
          {
            tramite_id: "22",
            establecimiento_id: document.querySelector("#ce_establecimientos")
              .value,
            tipo_importacion_id:
              document.querySelector("#tipoimportacion").value,
          },
          "POST"
        ).then((data) => {
          Api.loading(false);
          Swal.fire({
            title: "Solicitud exitosa",
            icon: "success",
            text: data.message,
          }).then(() => {
            window.location = "/solicitud-casos-especiales";
          });
        });
      }
    });
  }
  handleBajaEstablecimiento() {
    let est = this.state.establecimiento_id_baja;
    let tipo = this.state.tipo_establecimiento_baja_id;
    let act_id = this.state.licencia_id_baja_e;
    let nombre_persona = document.querySelector("#nombre_persona").value;
    let valido = 1;

    if (est === "") {
      this.mensajeError("Error", "Seleccione");
      valido = 0;
    }

    if (tipo === "") {
      this.mensajeError("Error", "Seleccione");
      valido = 0;
    }

    if (act_id === "") {
      this.mensajeError("Error", "Seleccione");
      valido = 0;
    }

    if (
      this.state.existe_orden === true &&
      (nombre_persona === "" || nombre_persona === undefined)
    ) {
      this.mensajeError(
        "Error",
        "Ingrese a nombre de quien va a estar la orden de pago."
      );
      valido = 0;
    }

    if (valido) {
      Swal.fire({
        title: "Baja establecimiento",
        text: "¿Seguro que desea enviar la solicitud de baja?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/generarOrdenPagoEstablecimiento",
            {
              tramite_id: "12",
              establecimiento_id: est,
              actividad_id: act_id,
              tipo: tipo,
              nombre_persona: nombre_persona,
              existe_orden: this.state.existe_orden,
            },
            "POST"
          ).then((data) => {
            Api.loading(false);
            Swal.fire({
              title: "Solicitud exitosa",
              icon: "success",
              text: data.message,
            }).then(() => {
              window.location = "/establecimientos";
            });
          });
        }
      });
    }
  }

  handlePreCertificadoProducto() {
    let precertificado = { ...this.state.precertificado };

    let nombre_persona = document.querySelector("#nombre_persona").value;
    let valido = 1;

    if (
      this.state.existe_orden === true &&
      (nombre_persona === "" || nombre_persona === undefined)
    ) {
      this.mensajeError(
        "Atención",
        "Favor de agregar el nombre de la persona."
      );
      valido = 0;
    }

    if (parseInt(precertificado.cantidad) !== precertificado.facturas.length) {
      this.mensajeError(
        "Atención",
        "La cantidad de créditos debe ser igual a la cantidad de factura(s)."
      );
      valido = 0;
    }

    if (precertificado.fin_exportacion_id === "") {
      this.mensajeError("Atención", "Favor de revisar el fin de exportación");
      valido = 0;
    }

    if (precertificado.facturas.length === 0) {
      this.mensajeError("Atención", "Favor de agregar factura(s).");
      valido = 0;
    }

    if (precertificado.cantidad === "") {
      this.mensajeError("Atención", "Favor de revisar la cantidad de créditos");
      valido = 0;
    }

    if (precertificado.tipo_precertificado === "") {
      this.mensajeError(
        "Atención",
        "Favor de revisar el tipo de precertificado"
      );
      valido = 0;
    }

    if (valido) {
      Api.loading(true);
      Api.fetch(
        "app/generarOrdenProducto",
        {
          tramite_id: this.state.tramite_id,
          cantidad: precertificado.cantidad,
          facturas: precertificado.facturas,
          fin_exportacion_id: precertificado.fin_exportacion_id,
          tipo_precertificado: precertificado.tipo_precertificado,
          existe_orden: this.state.existe_orden,
          nombre_persona: nombre_persona,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    }
  }

  handleTipoEstablecimiento(e) {
    this.setState({ tipo_establecimiento: e.target.value });
    Api.fetch(
      "app/getEstablishmentsActivities?tipo_establecimiento=" + e.target.value
    ).then((data) => {
      if (data) {
        this.setState({ options_activities: data.actividades });
      }
    });
  }

  handleSubmit(event) {
    if (event.tramite_id === "3") {
      //licencia establecimiento
      Api.loading(true);
      let establecimiento =
        event.establecimiento === undefined ? "" : event.establecimiento;

      Api.fetch(
        "app/generarOrdenPagoEstablecimiento",
        {
          tramite_id: event.tramite_id,
          esNuevo: event.esNuevo,
          tipo: event.tipo,
          establecimiento: establecimiento,
          actividad: event.actividad,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "4") {
      //licencia producto
      Api.loading(true);

      Api.fetch(
        "app/generarOrdenProducto",
        {
          tramite_id: event.tramite_id,
          tipoProducto: event.tipoProducto,
          establecimiento: event.establecimiento,
          tipoRegistro: event.tipoRegistro,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "6") {
      Api.loading(true);
      Api.fetch(
        "app/generateOrdenConstancia",
        {
          tramite_id: event.tramite_id,
          cons_tipo_id: event.cons_tipo_id,
          cons_texto: event.cons_texto,
          est_id: event.est_id,
          act_id: event.act_id,
          reg_tipo_id: event.reg_tipo_id,
          productos: event.productos,
          representante: event.representante,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => {
          Api.loading(false);
          Swal.fire({
            title: "Solicitud exitosa",
            icon: "success",
            text: data.message,
          }).then(() => {
            window.location = "/tramites";
          });
        })
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "8") {
      //licencia establecimiento

      Api.loading(true);
      //let establecimiento = (event.establecimiento === undefined) ? "": event.establecimiento;

      Api.fetch(
        "app/generarOrdenProducto",
        {
          tramite_id: event.tramite_id,
          establecimiento_id: event.establecimiento,
          producto_id: event.productos,
          anotacion_marginal_id: event.anotacion_marginal,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "9") {
      //reposicion licencia regente

      Api.loading(true);

      Api.fetch(
        "app/generarOrdenReposicionLicRegente",
        {
          tramite_id: event.tramite_id,
          licencia_id: event.reposicionLicRegente,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "10") {
      //reposicion licencia establecimiento
      Api.loading(true);

      Api.fetch(
        "app/generarOrdenPagoEstablecimiento",
        {
          tramite_id: event.tramite_id,
          //licencia_establecimiento_id: event.licencia_establecimiento,
          establecimiento: event.establecimiento,
          actividad: event.actividad,
          tipo: event.tipo,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "11") {
      //refrenda producto
      Api.loading(true);
      Api.fetch(
        "app/generateOrdenRefrenda",
        {
          tramite_id: event.tramite_id,
          titular_id: event.titular_id,
          fabricate_id: event.fabricate_id,
          pais_id: event.pais_id,
          productos: event.productos,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => {
          Swal.fire({
            title: "Solicitud exitosa",
            icon: "success",
            text: data.message,
          }).then(() => {
            window.location = "/tramites";
          });
        })
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "13" || event.tramite_id === "25") {
      //renovacion licencia establecimiento
      Api.loading(true);
      //let establecimiento = (event.establecimiento === undefined) ? "": event.establecimiento;

      Api.fetch(
        "app/generarOrdenPagoEstablecimiento",
        {
          tramite_id: event.tramite_id,
          //licencia_establecimiento_id: event.renovacion_establecimiento,
          establecimiento: event.establecimiento,
          actividad: event.actividad,
          tipo: event.tipo,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "14") {
      //
      Api.loading(true);
      Api.fetch(
        "app/generarOrdenProducto",
        {
          tramite_id: event.tramite_id,
          producto_id: event.productos,
          nombre_persona: event.nombre_persona,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "15") {
      //
      let nombre_persona = document.querySelector("#nombre_persona").value;
      let valido = 1;

      if (event.productos === undefined) {
        this.mensajeError("Error", "Seleccione");
        valido = 0;
      }

      if (
        this.state.existe_orden === true &&
        (nombre_persona === "" || nombre_persona === undefined)
      ) {
        this.mensajeError(
          "Error",
          "Ingrese a nombre de quien va a estar la orden de pago."
        );
        valido = 0;
      }

      if (valido) {
        Swal.fire({
          title: "Baja producto",
          text: "¿Seguro que desea enviar la solicitud de baja?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Regresar",
          reverseButtons: true,
          cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        }).then((result) => {
          if (result.isConfirmed) {
            Api.loading(true);
            Api.fetch(
              "app/generaOrdenPagoBajaProducto",
              {
                producto: event.productos,
                nombre_persona: event.nombre_persona,
                existe_orden: this.state.existe_orden,
              },
              "POST"
            )
              .then((data) => {
                Swal.fire({
                  title: "Solicitud",
                  icon: "success",
                  text: data.message,
                }).then(() => {
                  window.location = "/productos/listado";
                });
              })
              .catch((error) => {
                error.json().then((message) => {
                  Api.loading(false);
                  Swal.fire({
                    title: "Ocurrió un error al procesar la solicitud",
                    icon: "error",
                    text: message.message,
                  });
                }); //catching errors to show notification
              });
          }
        });
      }
    } else if (event.tramite_id === "17") {
      Api.loading(true);
      Api.fetch(
        "app/generarOrdenProducto",
        {
          tramite_id: event.tramite_id,
          tipo_certificado_id: event.tipo_certificado,
          establecimiento_id: event.establecimiento,
          nombre_persona: event.nombre_persona,
          num_certificados: event.num_certificados,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "19") {
      Api.loading(true);
      Api.fetch(
        "app/generarOrdenPrecertificadoCons",
        {
          tramite_id: event.tramite_id,
          establecimiento_id: event.establecimiento,
          nombre_persona: event.nombre_persona,
          cantidad_precertificado: event.cantidad_precertificado,
          existe_orden: this.state.existe_orden,
        },
        "POST"
      )
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            Api.loading(false);
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: message.message,
            });
          }); //catching errors to show notification
        });
    } else if (event.tramite_id === "24") {
      //autorización de adquisición
      let valido = 1;

      if (event.establecimiento === undefined) {
        this.mensajeError("Error", "Seleccione");
        valido = 0;
      }

      if (valido) {
        //NUNCA va a tener orden de pago
        Api.loading(true);
        Api.fetch(
          "app/generarSolicitudAdquisicion",
          {
            establecimiento_id: event.establecimiento,
            tramite_id: event.tramite_id,
          },
          "POST"
        ).then((data) => {
          Swal.fire({
            title: "Solicitud generada",
            icon: "success",
            text: data.message,
          }).then(() => {
            window.location = "/subproductos/autorizacion-de-adquisicion";
          });
        });
      }
    }
  }

  handleRegister(e) {
    if (e.message !== "Su solicitud ha sido recibida exitosamente.") {
      /* let tplErrors = `Los siguientes campos son obligatorios: <u>`;
      for (let err in e.errors) {
        tplErrors += `<li>${err
          .replace("_id", "")
          .replace("_", " ")
          .toUpperCase()}</li>`;
      } */
      let tplErrors = `<ul>`;
      for (let err in e.errors) {
        if (err.includes("_id")) {
          tplErrors += `<li>${e.errors[err][0].replace("id", "")}</li>`;
        } else {
          tplErrors += `<li>${e.errors[err]}</li>`;
        }
      }

      tplErrors += `</ul>`;
      Swal.fire({
        title: "Atención, verifique el formulario",
        icon: "error",
        html: tplErrors,
      });
    } else {
      Swal.fire({
        title: "Orden de pago generada",
        icon: "success",
        text: e.message,
      }).then(() => {
        window.location = "/tramites";
      });
    }
  }

  handleGuidEstablecimiento(e) {
    let est_state = { ...this.state.establecimiento };
    let name = e.target.id;

    switch (name) {
      case "razon_social_e":
        est_state["razon_social"] = e.target.value.toUpperCase();
        this.setState({ establecimiento: est_state });
        break;
      case "guid_e":
        est_state["guid"] = e.target.value.toUpperCase();
        this.setState({ establecimiento: est_state });
        break;
      case "addEst":
        if (est_state["razon_social"] === "" || est_state["guid"] === "") {
          this.mensajeError("Error", "Favor de llenar bien los campos.");
          return;
        }

        Api.loading(true);
        Api.fetch("app/getValidEstablishmentByGUID", est_state, "POST").then(
          (data) => {
            this.handleExisteEstablecimiento(data);
          }
        );
        break;
      default:
        break;
    }
  }

  handleExisteEstablecimiento(data) {
    Api.loading(false);

    if (data.id) {
      let est_state = { ...this.state.establecimiento };
      est_state["id"] = data.id;
      this.setState({ establecimiento: est_state, disable_ame: true });

      let adr = document.querySelector("#addEst");
      adr.classList = "form-control btn btn-success";
      document.querySelector("#addEst i").classList = "fas fa-check";
    } else {
      this.mensajeError(
        "Error al buscar el establecimiento",
        "No se encontrarion establecimientos validos con esos datos."
      );
    }
  }

  /*   addEstablecimientos(e) {
    let est = { ...this.state.establecimiento };

    let adr = this.forma_MedicoVeterinario.querySelector("#validar_guid");
    if (adr.classList === "btn btn-light") {
      return;
    }

    let establecimientos = this.state.establecimientos;

    for (let re in establecimientos) {
      if (establecimientos[re].razon_social === est.razon_social) {
        this.mensajeError(
          "Atención",
          "Ya cuenta con este establecimiento en su lista."
        );
        adr.classList = "form-control btn btn-light";
        document.querySelector("#validar_guid i").classList = "fa fa-th";
        return false;
      }
    }

    establecimientos.push(est);
    this.setState({ establecimientos: establecimientos });
    adr.classList = "form-control btn btn-light";
    document.querySelector("#validar_guid i").classList = "fa fa-th";

    let establecimiento = {
      establecimiento_id: "",
      razon_social: "",
      guid: "",
    };

    this.setState({ establecimiento: establecimiento });

    this.forma_MedicoVeterinario.querySelector("#razon_social").value = "";
    this.forma_MedicoVeterinario.querySelector("#guid").value = "";
  }

  removeEstablecimientos(e) {
    let lista_establecimientos = [...this.state.establecimientos];
    lista_establecimientos.splice(e.target.id, 1);
    this.setState({ establecimientos: lista_establecimientos });
  } */

  mensajeError(titulo, msg) {
    Swal.fire({
      title: titulo,
      icon: "warning",
      text: msg,
    });
  }

  limpiarForm() {
    let constancia = document.querySelector("#f_constancias");
    constancia.hide("nombre_persona");

    constancia.querySelector("#establecimiento_id").value = "0";
    let options = `<option value="0">Seleccione establecimiento</option>`;
    constancia.querySelector("#establecimiento_id").innerHTML = options;

    constancia.querySelector("#regente_tipo_id").value = "0";
    options = `<option value="0" regente_id="">Seleccione el tipo de regente</option>`;
    constancia.querySelector("#regente_tipo_id").innerHTML = options;

    constancia.querySelector("#actividad_id").value = "0";
    options = `<option value="0">Seleccione actividad</option>`;
    constancia.querySelector("#actividad_id").innerHTML = options;

    constancia.querySelector("#peticion").value = " ";
    let vacio = [];
    this.setState({
      productos: vacio,
      reg_id: "",
      existe_orden: false,
      representante_nom: "",
    });
  }

  limpiarForm_Refrenda() {
    let refrenda = document.querySelector("#f_refrenda");

    refrenda.querySelector("#titular").value = "0";
    let options = `<option value="0">Seleccione el establecimiento titular</option>`;
    refrenda.querySelector("#titular").innerHTML = options;

    refrenda.querySelector("#fabricante").value = "0";
    options = `<option value="0">Seleccione el establecimiento fabricante</option>`;
    refrenda.querySelector("#fabricante").innerHTML = options;

    refrenda.querySelector("#pais").value = "0";
    options = `<option value="0">seleccione el país de origen</option>`;
    refrenda.querySelector("#pais").innerHTML = options;

    this.setState({ productos_refrenda: [] });
  }

  validarFormRefrenda(data) {
    let valido = 1;

    if (
      data.productos === undefined ||
      data.productos === null ||
      data.productos.length === 0
    ) {
      this.mensajeError("Error", "Favor de ingresar al menos un producto.");
      valido = 0;
    }

    if (data.pais_id === "0") {
      this.mensajeError("Error", "Favor de seleccionar el país.");
      valido = 0;
    }

    if (data.fabricate_id === "0") {
      this.mensajeError("Error", "Favor de seleccionar el fabricante.");
      valido = 0;
    }

    if (data.titular_id === "0") {
      this.mensajeError("Error", "Favor de seleccionar el titular.");
      valido = 0;
    }

    if (
      data.existe_orden === true &&
      (data.nombre_persona === undefined || data.nombre_persona === "")
    ) {
      this.mensajeError(
        "Error",
        "Favor ingresar a que persona se hará la orden."
      );
      valido = 0;
    }

    if (valido) {
      this.handleSubmit(data);
    }
  }

  handleEstablecimientosRepRegTitularesFabricantes() {
    let constancia = document.querySelector("#f_constancias");
    Api.fetch("app/getEstablecimientosRepRegActividades").then((data) => {
      let options = `<option value="">Seleccione establecimiento</option>`;
      if (data) {
        let establecimientos = data;

        for (let e in establecimientos) {
          options += `<option value="${establecimientos[e].id}">
            ${establecimientos[e].razon_social} [${establecimientos[e].folio_establecimiento}]
            </option>`;
        }
      }
      constancia.querySelector("#establecimiento_id").innerHTML = options;
    });
  }

  handleProductosChange(e) {
    this.setState({ productos: e });
  }

  handleProductosRefrendaChange(e) {
    this.setState({ productos_refrenda: e });
  }

  validarFormConstancia(data) {
    let valido = 1;
    let textoLibre = [1, 2, 3, 12];
    let encuentra_tl = textoLibre.includes(parseInt(data.cons_tipo_id));

    if (encuentra_tl) {
      if (data.cons_texto === " ") {
        this.mensajeError("Error", "Favor de ingresar petición.");
        valido = 0;
      }
    } else {
      if (data.cons_tipo_id === "4") {
        if (data.act_id === "0") {
          this.mensajeError("Error", "Favor de seleccionar la actividad.");
          valido = 0;
        }
        if (data.est_id === "0") {
          this.mensajeError(
            "Error",
            "Favor de seleccionar el establecimiento."
          );
          valido = 0;
        }
      } else if (data.cons_tipo_id === "5") {
        if (data.est_id === "0") {
          this.mensajeError(
            "Error",
            "Favor de seleccionar el establecimiento."
          );
          valido = 0;
        }
        if (data.reg_tipo_id === "0") {
          this.mensajeError(
            "Error",
            "Favor de seleccionar el tipo de regente."
          );
          valido = 0;
        }
      } else if (
        data.cons_tipo_id === "6" ||
        data.cons_tipo_id === "7" ||
        data.cons_tipo_id === "8" ||
        data.cons_tipo_id === "10" ||
        data.cons_tipo_id === "11"
      ) {
        if (
          data.productos === undefined ||
          data.productos === null ||
          data.productos.length === 0
        ) {
          this.mensajeError(
            "Error",
            "Favor de seleccionar al menos un producto."
          );
          valido = 0;
        }
        if (data.est_id === "0" || data.est_id === undefined) {
          this.mensajeError(
            "Error",
            "Favor de seleccionar el establecimiento."
          );
          valido = 0;
        }
      } else if (data.cons_tipo_id === "9") {
        if (data.est_id === "0") {
          this.mensajeError(
            "Error",
            "Favor de seleccionar el establecimiento."
          );
          valido = 0;
        }
      }
    }

    if (
      data.existe_orden === true &&
      (data.nombre_persona === undefined || data.nombre_persona === "")
    ) {
      this.mensajeError(
        "Error",
        "Favor ingresar a que persona se hará la orden."
      );
      valido = 0;
    }

    if (data.cons_tipo_id === "0") {
      this.mensajeError("Error", "Favor de seleccionar un tipo de constancia.");
      valido = 0;
    }

    if (valido) {
      this.handleSubmit(data);
    }
  }

  handleChangeEstablecimientoBaja(e_id) {
    this.setState({ establecimiento_id_baja: e_id });

    Api.fetch("app/getTiposDelEstablecimiento?establecimiento_id=" + e_id).then(
      (data) => {
        let tipo = data;
        let options = `<option value="">Seleccione el tipo de establecimiento</option>`;
        for (let e in tipo) {
          options += `<option value="${tipo[e].id}">
          ${tipo[e].descripcion}
          </option>`;
        }
        document.querySelector("#baja_establecimiento_tipo_id").innerHTML =
          options;
      }
    );
  }

  handleChangeTipoEstablecimientoBaja(e_id) {
    this.setState({ tipo_establecimiento_baja_id: e_id });
    let est_id = this.state.establecimiento_id_baja;

    Api.fetch(
      "app/getLicenciasConActividadEstablecimiento?establecimiento_id=" +
        est_id +
        "&tipo=" +
        e_id
    ).then((data) => {
      let licencias = data;
      let options = `<option value="">Seleccione actividad de licencia</option>`;
      for (let e in licencias) {
        options += `<option value="${licencias[e].id}">
          ${licencias[e].descripcion}  [${licencias[e].folio_licencia}]
          </option>`;
      }
      document.querySelector("#baja_licencia_establecimiento_id").innerHTML =
        options;
    });
  }

  handlePreCertificado(e) {
    let rep = { ...this.state.precertificado };
    rep[e.target.name] = e.target.value.toUpperCase();

    if (e.target.name === "cantidad") {
      let entero = /^[1-9]\d*$/;
      if (e.target.value === "" || entero.test(e.target.value)) {
        rep["cantidad"] = e.target.value;
        this.setState({ precertificado: rep });
      } else {
        return;
      }
    }

    this.setState({ precertificado: rep });
  }

  addNumFacturaPrecertificado(e) {
    let precertificado = { ...this.state.precertificado };
    let pa = [...this.state.precertificado.facturas];
    if (precertificado["num_factura"] !== "") {
      pa.push(precertificado["num_factura"]);
      precertificado["facturas"] = pa;
      precertificado["num_factura"] = "";
      this.setState({
        precertificado: precertificado,
      });
    }
  }

  removeNumFacturaPrecertificado(e) {
    let precertificado = { ...this.state.precertificado };
    let facturas = [...this.state.precertificado.facturas];

    facturas.splice(e.target.id, 1);
    precertificado["facturas"] = facturas;
    this.setState({
      precertificado: precertificado,
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/solicitud-tramites">Solicitud trámite</Link>
          </li>
        </ol>
        <h1 className="page-header">Solicitud trámite</h1>

        <div className="row">
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <fieldset className="col-sm-12">
                  <div id="solicitud"></div>
                  <div className="hide" id="f_MedicoVeterinario"></div>
                  {/* <hr></hr> */}
                  <div className="hide" id="f_constancias"></div>
                  <div className="hide" id="check_productos">
                    <label>Productos:</label>
                    <div id="select" className="form-group">
                      <Select
                        isMulti
                        id="selectMulti"
                        styles={colourStyles}
                        placeholder="Seleccione"
                        defaultValue={this.state.productos}
                        value={this.state.productos}
                        onChange={(e) => this.handleProductosChange(e)}
                        theme="neutral40"
                        options={this.state.options_productos}
                        getOptionLabel={(producto) =>
                          producto.nombre_comercial +
                          "(" +
                          producto.no_registro +
                          ")"
                        }
                        getOptionValue={(producto) => producto.id}
                        getOptionNoRegistro={(producto) => producto.no_registro}
                        noOptionsMessage={() => "No se encontraron productos"}
                      />
                    </div>
                  </div>
                  {/*baja establecimiento*/}
                  <div
                    id="bajaEst"
                    className={this.state.tramite_id === "12" ? "" : "hide"}
                  >
                    <div>Seleccione el establecimiento</div>
                    <select
                      className="form-control"
                      id="baja_establecimiento_id"
                      //onChange={e => this.handleBajaEstablecimiento(e.target.value)}>
                      value={this.state.establecimiento_id_baja}
                      onChange={(e) =>
                        //this.setState({ establecimiento_id_baja: e.target.value })
                        this.handleChangeEstablecimientoBaja(e.target.value)
                      }
                    >
                      <option>Cargando...</option>
                    </select>

                    <div>Seleccione tipo establecimiento</div>
                    <select
                      className="form-control"
                      id="baja_establecimiento_tipo_id"
                      value={this.state.tipo_establecimiento_baja_id}
                      onChange={(e) =>
                        //this.setState({ tipo_establecimiento_baja_id: e.target.value })
                        this.handleChangeTipoEstablecimientoBaja(e.target.value)
                      }
                    >
                      <option>Seleccione tipo establecimiento</option>
                    </select>

                    <div>Seleccione actividad de licencia</div>
                    <select
                      className="form-control"
                      id="baja_licencia_establecimiento_id"
                      value={this.state.licencia_id_baja_e}
                      onChange={(e) =>
                        this.setState({ licencia_id_baja_e: e.target.value })
                      }
                    >
                      <option>Seleccione actividad de licencia</option>
                    </select>
                  </div>

                  {/*anotacion marginal establecimiento*/}
                  <div
                    id="cmbanotaciones"
                    className={this.state.tramite_id === "7" ? "" : "hide"}
                  >
                    <div>Tipo anotación marginal</div>
                    <select className="form-control" id="anotaciones">
                      <option>Cargando...</option>
                    </select>
                    <hr></hr>
                  </div>
                  <div id="ame" className="hide">
                    <div>Seleccione el establecimiento</div>
                    <select
                      className="form-control"
                      id="ameid"
                      value={this.state.ame}
                      onChange={(e) => this.setState({ ame: e.target.value })}
                    >
                      <option>Cargando...</option>
                    </select>
                  </div>
                  <div id="ameGuid" className="hide">
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label>Razón social</label>
                        <span className="text-danger"> *</span>{" "}
                        <input
                          type="text"
                          name="razon_social"
                          id="razon_social_e"
                          onChange={this.handleGuidEstablecimiento}
                          value={this.state.establecimiento.razon_social}
                          className="form-control"
                          placeholder="Ingrese razón social "
                          disabled={this.state.disable_ame}
                          required
                        />
                      </div>

                      <div className="form-group col-md-5">
                        <label>GUID</label>
                        <span className="text-danger"> *</span>{" "}
                        <input
                          type="text"
                          name="guid"
                          id="guid_e"
                          onChange={this.handleGuidEstablecimiento}
                          value={this.state.establecimiento.guid}
                          className="form-control"
                          maxLength="4"
                          placeholder="Ingrese GUID "
                          required
                          disabled={this.state.disable_ame}
                        />
                      </div>

                      <div
                        className="col-md-1"
                        aria-disabled={this.state.disable_ame}
                      >
                        <br />
                        <div
                          id="addEst"
                          name="btnEst"
                          onClick={this.handleGuidEstablecimiento}
                          className=" btn btn-light"
                        >
                          <i className="fa fa-th" name="btnEst"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    id="casosespeciales"
                    className={this.state.tramite_id === "22" ? "" : "hide"}
                  >
                    <div>Seleccione tipo de importación</div>
                    <select className="form-control" id="tipoimportacion">
                      <option>Cargando...</option>
                    </select>
                    <div id="estiim" className="hide">
                      <div>Seleccione el establecimiento</div>
                      <select
                        className="form-control"
                        id="ce_establecimientos"
                      ></select>
                    </div>
                  </div>

                  <div className="hide" id="f_refrenda"></div>
                  <div className="hide" id="refreda_productos">
                    <label>Productos:</label>
                    <div id="select" className="form-group">
                      <Select
                        isMulti
                        id="selectMulti"
                        styles={colourStyles}
                        placeholder="Seleccione"
                        defaultValue={this.state.productos_refrenda}
                        value={this.state.productos_refrenda}
                        onChange={(e) => this.handleProductosRefrendaChange(e)}
                        theme="neutral40"
                        options={this.state.options_productos_refrenda}
                        getOptionLabel={(producto) =>
                          producto.nombre_comercial +
                          "(" +
                          producto.no_registro +
                          ")"
                        }
                        getOptionValue={(producto) => producto.id}
                        getOptionNoRegistro={(producto) => producto.no_registro}
                        noOptionsMessage={() => "No se encontraron productos"}
                      />
                    </div>
                  </div>

                  {/*Precertificados*/}

                  <div
                    id="PreCer"
                    className={
                      this.state.tramite_id === "23" &&
                      this.state.tipo_precertificado !== ""
                        ? ""
                        : "hide"
                    }
                  >
                    <div>Cantidad de créditos</div>
                    {/* <select className="form-control" 
                      id="baja_establecimiento_id"  
                      value={this.state.establecimiento_id_baja}
                      onChange={(e) =>
                        this.handleChangeEstablecimientoBaja(e.target.value)
                      }
                      > 
                      
                      <option>Cargando...</option>
                    </select>*/}
                    <input
                      type="text"
                      name="cantidad"
                      value={this.state.precertificado.cantidad}
                      onChange={this.handlePreCertificado}
                      className="form-control"
                      placeholder="Ingrese cantidad"
                      //min={1}
                      maxLength={7}
                      required
                    />

                    <div>Número de factura</div>
                    <div className="row form-group">
                      <input
                        name="num_factura"
                        type="input"
                        maxLength={30}
                        onChange={this.handlePreCertificado}
                        value={this.state.precertificado.num_factura}
                        className="form-control col-md-10"
                        placeholder="Número de factura"
                        //required
                      />
                      <div
                        className="form-group col-md-2"
                        style={{ marginTop: "1.5em" }}
                      >
                        <button
                          type="button"
                          className="btn btn-info col-md-12"
                          onClick={this.addNumFacturaPrecertificado}
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <div
                      className={
                        this.state.precertificado.facturas.length > 0
                          ? "row"
                          : "row hide"
                      }
                    >
                      <div id="listaPresentaciones" className="col-md-12">
                        <table className="table table-striped m-b-0 table-hover">
                          {/* <thead>
                          <tr>
                            <th>Presentaciones cantidad</th>
                            <th>Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead> */}
                          <tbody>
                            {this.state.precertificado.facturas.map(
                              (factura, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{factura}</td>
                                  <td>
                                    <button
                                      id={index}
                                      onClick={
                                        this.removeNumFacturaPrecertificado
                                      }
                                      className="btn btn-warning pull-right"
                                    >
                                      <i
                                        id={index}
                                        onClick={
                                          this.removeNumFacturaPrecertificado
                                        }
                                        className="fas fa-trash"
                                      ></i>
                                    </button>
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div>Fines de exportación</div>
                    <select
                      onChange={this.handlePreCertificado}
                      name="fin_exportacion_id"
                      className="form-control"
                      value={this.state.precertificado.fin_exportacion_id}
                    >
                      <option value="0" className="dropdown-item">
                        Seleccione...
                      </option>
                      {this.state.options_fin_exportacion.map((option) => (
                        <option
                          className="dropdown-item"
                          key={option.id}
                          value={option.id}
                        >
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="hide" id="btn_generar"></div>
                </fieldset>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <ReceiptRequest auth={auth} history={history} {...props} />;
};
